/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { useEffect, useState } from "react";
import AppendHead from "react-append-head";

import {
  Checkbox,
  CircularProgress,
  Container,
  FormControlLabel,
  Grid,
  MenuItem,
  Portal,
  Typography,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";

import FormInput from "../FormInput";

import Alert from "@material-ui/lab/Alert";
import { Link } from "@mui/material";
import { useGlobal } from "../../contexts/globalContext";
import getCompanyLogos from "../../mock/companyLogos";
import BookingsRepository from "../../repositories/bookingsRepository";
import getByTag from "../../repositories/termRepository";
import UserRepository from "../../repositories/userRepository";
import { getClientIpAddress } from "../../services/get-client-ip";
import { getCep } from "../../services/via-cep.datasource";
import { addFeeByDestinoFerias } from "../../utils/addFeeByDestinoFerias";
import {
  buildBusCheckRateRequest,
  calcBusPointsTotal,
  mapBusPolicies,
} from "../../utils/busMapper";
import { mapHotelCheckRateError, getCheckoutErrorMessage } from "../../utils/checkoutErrors";
import createCard64 from "../../utils/createCard64";
import { discountTypeEnum } from "../../utils/enum";
import cardFlag from "../../utils/getFlagCard";
import { getSessionStorage } from "../../utils/getSessionStorage";
import {
  buildCheckRateRequest,
  buildOccupancyForCheckRate,
  buildOrinterGuests,
} from "../../utils/hotelMapper";
import { ufs } from "../../utils/ufList";
import { validCPF, validEmail } from "../../utils/validator";
import Auth2faModal from "../Auth2FaModal";
import CardFlags from "../CardFlags";
import Loader from "../Loader";
import SimpleModal from "../SimpleModal";
import ThemeButton from "../ThemeButton";
import CarSideSummary from "./CarSideSummary";
import CarPoliciesModal from "../CarPoliciesModal";
import CarSummaryCard from "./CarSummaryCard";
import EntertainmentSideSummary from "./EntertainmentSideSummary";
import ExperienceSideSummary from "./ExperienceSideSummary";
import FlightSideSumary from "./FlightSideSumary";
import FlightSummaryCard from "./FlightSummaryCard";
import HotelSideSummary from "./HotelSideSummary";
import HotelSummaryCard from "./HotelSummaryCard";
import * as S from "./styles";

import { MAX_INSTALLMENTS } from "../../constants/constants";

import CarRepository from "../../repositories/carRepository";
import DiscountRepository from "../../repositories/discountRepository";
import EntertainmentRepository from "../../repositories/entertainmentRepository";
import getFlightPricing from "../../repositories/getFlightPricing";
import HotelRepository from "../../repositories/hotelRepository";
import PackageRepository from "../../repositories/packageRepository";
import translateText from "../../utils/translateText";
import SimpleBusModal from "../SimpleBusModal";
import BusRepository from "./../../repositories/busRepository";
import BusSideSummary from "./BusSideSummary";
import BusSummaryCard from "./BusSummaryCard";
import PackageSideSummary from "./PackageSideSummary";
import PackageSummaryCard from "./PackageSummaryCard";

const requiresCpfDocument = (product) =>
  ["Carro", "Hotel", "Pacote"].includes(product);

const SummaryContent = ({
  searchState,
  buscaAtual,
  addressCode,
  ltnSession,
}) => {
  const CodeAntiFraud = crypto.randomUUID();
  const ORG_ID = "1snn5n9w";
  const URL = `https://h.onlinemetrix.net/fp/tags.js?org_id=${ORG_ID}&session_id=adiq_br${CodeAntiFraud}`;

  const { showAlert, setLoading, user, signed, login } = useGlobal();
  let history = useHistory();

  const bookingsRepository = new BookingsRepository();
  const userRepository = new UserRepository();
  const busRepository = new BusRepository();
  const entertainmentRepository = new EntertainmentRepository();
  const discountRepository = new DiscountRepository();

  const [cardValidationError, setCardValidationError] = useState("");
  const [isValidatingCard, setIsValidatingCard] = useState(false);
  const [installmentsNumber, setInstallmentsNumber] = useState([]);
  const [dataSelected, setDataSelected] = useState();
  const [goingFlight, setGoingFlight] = useState();
  const [returnFlight, setReturnFlight] = useState();
  const [goingRoute, setGoingRoute] = useState();
  const [returnRoute, setReturnRoute] = useState();
  const [selectedGoingSeats, setSelectedGoingSeats] = useState([]);
  const [selectedReturnSeats, setSelectedReturnSeats] = useState([]);
  const [result, setResult] = useState({});
  const [seatMapIda, setSeatMapIda] = useState([]);
  const [seatMapVolta, setSeatMapVolta] = useState([]);
  const [loadingSeats, setLoadingSeats] = useState(false);
  const [policies, setPolicies] = useState([]);
  const [passengers, setPassengers] = useState([]);
  const [state, setState] = useState({});
  const [quartos, setQuartos] = useState([]);
  const [roomDistribution, setRoomDistribution] = useState([]);
  const [send, setSend] = useState(false);
  const [error, setError] = useState("");
  const [openLoader, setOpenLoader] = useState(false);
  const [userCardDataSaved, setUserCardDataSaved] = useState("");
  const [useSavedCard, setUseSavedCard] = useState(false);
  const [openModal2fa, setOpenModal2fa] = useState(false);
  const [paymentData, setPaymentData] = useState({});
  const [bookingSuccessCode, setBookingSuccessCode] = useState({});
  const [discountCoupon, setDiscountCoupon] = useState("");
  const [discountPoints, setDiscountPoints] = useState(0);
  const [campaignDiscountPoints, setCampaignDiscountPoints] = useState(0);
  const [campaignDiscountCash, setCampaignDiscountCash] = useState(0);
  const [couponDiscountPercentage, setCouponDiscountPercentage] = useState(0);
  const [discountPercentage, setDiscountPercentage] = useState(0);
  const [discountCash, setDiscountCash] = useState(0);
  const [couponError, setCouponError] = useState("");
  const [fees, setFees] = useState(0);
  const [minimumPointsToBuy, setMinimumPointsToBuy] = useState(0);
  const [cashPrice, setCashPrice] = useState(0);
  const [cashTotalValue, setCashTotalValue] = useState(0);
  const [pointsPrice, setPointsPrice] = useState(0);
  const [pointsTotalValue, setPointsTotalValue] = useState(0);
  const [paymentInMoney, setPaymentInMoney] = useState(0);
  const [paymentInPoints, setPaymentInPoints] = useState(0);
  const [ipAddress, setIpAddress] = useState("");
  const [coinAlias, setCoinAlias] = useState("Pontos");
  const [activityCategory, setActivityCategory] = useState();
  const [isStartingAirport, setIsStartingAirport] = useState(false);
  const [isDestinationAirport, setIsDestinationAirport] = useState(false);
  const [transferData, setTransferData] = useState({
    startingAirport: {
      name: "",
      reservationCode: "",
      flightNumber: "",
      arrivalTime: "",
    },
    destinationAirport: {
      name: "",
      reservationCode: "",
      flightNumber: "",
      arrivalTime: "",
    },
    pickupLocation: "",
    dropOffLocation: "",
  });

  const userPoints = signed ? user.pointsBalance : 0;
  const [
    openServiceTermsAndPrivacyPolicyModal,
    setOpenServiceTermsAndPrivacyPolicyModal,
  ] = useState(false);

  const [
    openServiceTermsAndPrivacyPolicyBusModal,
    setOpenServiceTermsAndPrivacyPolicyBusModal,
  ] = useState(false);

  const [
    openHotelCancellationPolicyModal,
    setOpenHotelCancellationPolicyModal,
  ] = useState(false);
  const [hotelCancellationPolicyAccepted, setHotelCancellationPolicyAccepted] =
    useState(false);

  const [openCarPoliciesModal, setOpenCarPoliciesModal] = useState(false);
  const [carPoliciesData, setCarPoliciesData] = useState({ policies: [], cancellationPolicies: null });
  const [pendingCarBooking, setPendingCarBooking] = useState(null);
  const [carPriceUpdate, setCarPriceUpdate] = useState(null);

  const [
    openFlightCancellationPolicyModal,
    setOpenFlightCancellationPolicyModal,
  ] = useState(false);
  const [
    flightCancellationPolicyAccepted,
    setFlightCancellationPolicyAccepted,
  ] = useState(false);
  const [flightFareRulesData, setFlightFareRulesData] = useState(null);
  const [loadingFareRules, setLoadingFareRules] = useState(false);
  const [translatedRulesInfo, setTranslatedRulesInfo] = useState(null);
  const [isTranslating, setIsTranslating] = useState(false);

  const [useTerms, setUseTerms] = useState("");
  const [isGeneralLoading, setIsGeneralLoading] = useState(false);

  const [userDataAddress, setUserDataAddress] = useState({
    zipCode: "",
    address: "",
    number: "",
    city: "",
    state: "",
    complement: "",
    documentNumber: "",
    email: "",
    mobilePhoneNumber: "",
    ipAddress: "",
  });

  const conversionRate = signed
    ? user.catalog.catalogCurrencyConfig.conversionRate
    : 1;

  const sending = () => setSend(true);

  const getClientIp = async () => {
    const data = await getClientIpAddress();
    setIpAddress(data);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getClientIp();

    return () => {
      if (buscaAtual === "Pacote") {
        sessionStorage.removeItem("@PackageSelected");
        localStorage.removeItem("@packageRequest");
      }
    };
  }, [buscaAtual]);

  useEffect(async () => {
    const useTermsResponse = await getByTag("USE_TERMS_PRIVACY_POLICY");
    setUseTerms(useTermsResponse?.data);
  }, []);

  useEffect(() => {
    if (buscaAtual === "Aéreo")
      setDataSelected(getSessionStorage("@FlightSelected"));
    if (buscaAtual === "Carro")
      setDataSelected(getSessionStorage("@CarSelected"));
    if (buscaAtual === "Experiencias")
      setDataSelected(getSessionStorage("@ExperienceSelected"));
    if (buscaAtual === "Hotel")
      setDataSelected(
        Array.isArray(getSessionStorage("@roomSelected"))
          ? getSessionStorage("@roomSelected")[0]
          : getSessionStorage("@roomSelected"),
      );
    if (buscaAtual === "Rodoviário")
      setDataSelected(getSessionStorage("@BusSelected"));
    if (buscaAtual === "Entretenimento")
      setDataSelected(getSessionStorage("@EntertainmentSelected"));
  }, [buscaAtual]);

  useEffect(() => {
    if (buscaAtual === "Aéreo") {
      setGoingFlight(
        dataSelected?.recommendation.journeys[0].segments.find(
          (s) => s.segmentid.toString() === dataSelected?.going.split("-")[1],
        ),
      );
      if (dataSelected?.return)
        setReturnFlight(
          dataSelected?.recommendation.journeys[1].segments.find(
            (s) =>
              s.segmentid.toString() === dataSelected?.return.split("-")[1],
          ),
        );
    }
  }, [buscaAtual, dataSelected]);

  useEffect(() => {
    if (
      buscaAtual === "Aéreo" &&
      goingFlight &&
      !flightFareRulesData &&
      !loadingFareRules
    ) {
      const fetchFareRules = async () => {
        setLoadingFareRules(true);
        try {
          const segments = returnFlight
            ? [goingFlight, returnFlight]
            : [goingFlight];
          const response = await getFlightPricing({
            qtAdult: searchState?.adultos,
            qtChild: searchState?.criancas,
            qtBaby: searchState?.bebes,
            segments,
          });
          if (response?.data?.pricingbysource) {
            setFlightFareRulesData(response.data.pricingbysource[0]);
          }
        } catch (e) {
          console.error("Erro ao buscar regras tarifárias:", e);
        } finally {
          setLoadingFareRules(false);
        }
      };
      fetchFareRules();
    }
  }, [buscaAtual, goingFlight, returnFlight]);

  useEffect(() => {
    if (buscaAtual === "Rodoviário") {
      setGoingRoute(dataSelected?.selectedDepart);
      if (dataSelected?.selectedReturn)
        setReturnRoute(dataSelected?.selectedReturn);
    }
  }, [buscaAtual, dataSelected]);

  const handleTranslateFareRules = async () => {
    if (!flightFareRulesData?.rulesinfo || isTranslating) return;
    setIsTranslating(true);
    try {
      const translated = await Promise.all(
        flightFareRulesData.rulesinfo.map(async (segmentRule) => ({
          ...segmentRule,
          ruleText: await Promise.all(
            (segmentRule.ruleText || []).map(async (rule) => ({
              ...rule,
              title: rule.title ? await translateText(rule.title) : rule.title,
              text: rule.text ? await translateText(rule.text) : rule.text,
            })),
          ),
        })),
      );
      setTranslatedRulesInfo(translated);
    } catch (e) {
      console.error("Erro ao traduzir regras tarifárias:", e);
    } finally {
      setIsTranslating(false);
    }
  };

  window.__translateFareRules = handleTranslateFareRules;
  window.__showOriginalFareRules = () => setTranslatedRulesInfo(null);

  const createPassengerByPersonas = (adults, childs, babies) => {
    let pass = [];

    if (adults > 0) {
      for (var a = 0; a < adults; a++) {
        pass.push({ tipo: "Adulto", index: pass.length });
      }
    }
    if (childs > 0) {
      for (var c = 0; c < childs; c++) {
        pass.push({ tipo: "Criança", index: pass.length });
      }
    }
    if (babies > 0) {
      for (var b = 0; b < babies; b++) {
        pass.push({ tipo: "Bebê", index: pass.length });
      }
    }

    setPassengers(pass);

    setState({
      ...state,
      passengers: pass.map(() => ({
        name: "",
        ...(requiresCpfDocument(buscaAtual) ? { documentType: "CPF" } : {}),
      })),
    });

    return pass;
  };

  const createGuestsByPersonas = (adults, childAges) => {
    let pass = [];

    if (adults > 0) {
      for (var a = 0; a < adults; a++) {
        pass.push({ tipo: "Adulto", label: "Adulto", index: pass.length });
      }
    }
    if (childAges?.length > 0) {
      childAges.map((child, index) =>
        pass.push({
          tipo: "Criança",
          label: `Criança (${child}) anos`,
          index: pass.length,
        }),
      );
    }

    setPassengers(pass);

    setState({
      ...state,
      passengers: pass.map((index) => ({ name: "" })),
    });

    return pass;
  };

  const distributeGuestsAcrossRooms = (adults, childAges, qtRooms) => {
    const totalGuests = adults + (childAges?.length || 0);

    if (totalGuests < qtRooms) {
      setError(
        "A quantidade total de hóspedes deve ser maior ou igual à quantidade de quartos informados.",
      );
      return [];
    }

    if (adults < 1) {
      setError("É necessário informar pelo menos 1 adulto.");
      return [];
    }

    setError("");

    let roomDistribution = [];

    const adultsPerRoom = Math.floor(adults / qtRooms);
    const remainingAdults = adults % qtRooms;

    let adultsList = [];
    let currentRoom = 0;
    let adultsInCurrentRoom = 0;

    for (let a = 0; a < adults; a++) {
      const maxAdultsForCurrentRoom =
        currentRoom < remainingAdults ? adultsPerRoom + 1 : adultsPerRoom;

      if (
        adultsInCurrentRoom >= maxAdultsForCurrentRoom &&
        currentRoom < qtRooms - 1
      ) {
        currentRoom++;
        adultsInCurrentRoom = 0;
      }

      adultsList.push({
        tipo: "Adulto",
        label: "Adulto",
        index: a,
        roomIndex: currentRoom,
      });

      adultsInCurrentRoom++;
    }

    let childrenList = [];
    if (childAges?.length > 0) {
      childAges.forEach((child, index) => {
        childrenList.push({
          tipo: "Criança",
          label: `Criança (${child}) anos`,
          index: adults + index,
          roomIndex: 0,
        });
      });
    }

    for (let room = 0; room < qtRooms; room++) {
      const roomGuests = [
        ...adultsList.filter((guest) => guest.roomIndex === room),
        ...(room === 0 ? childrenList : []),
      ];

      roomDistribution.push({
        roomNumber: room,
        guests: roomGuests,
      });
    }

    return roomDistribution;
  };

  useEffect(() => {
    buscaAtual === "Aéreo" &&
      createPassengerByPersonas(
        searchState?.adultos,
        searchState?.criancas,
        searchState?.bebes,
      );

    buscaAtual === "Experiencias" &&
      createPassengerByPersonas(dataSelected?.adults, 0, 0);

    buscaAtual === "Carro" && createPassengerByPersonas(1, 0, 0);

    if (buscaAtual === "Hotel" && searchState) {
      const distribution = distributeGuestsAcrossRooms(
        searchState?.qtAdult,
        searchState?.childAge,
        searchState?.qtRooms,
      );
      setRoomDistribution(distribution);

      createGuestsByPersonas(searchState?.qtAdult, searchState?.childAge);
    }

    if (buscaAtual === "Pacote" && searchState) {
      const distribution = distributeGuestsAcrossRooms(
        searchState?.qtAdult,
        searchState?.childAge,
        searchState?.qtRooms,
      );
      setRoomDistribution(distribution);

      createGuestsByPersonas(searchState?.qtAdult, searchState?.childAge);
    }

    buscaAtual === "Rodoviário" &&
      createPassengerByPersonas(searchState?.passageiros, 0, 0);

    if (buscaAtual === "Entretenimento" && dataSelected?.passageiros) {
      const { adults, childs, babies } = mapPassengerData(
        dataSelected.passageiros,
      );

      createPassengerByPersonas(adults, childs, babies);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchState, dataSelected]);

  const mapPassengerData = (passengerObj) => {
    let adults = 0;
    let childs = 0;
    let babies = 0;

    Object.keys(passengerObj).forEach((key) => {
      if (key.includes("Adulto")) {
        adults += passengerObj[key];
      } else if (key.includes("Criança")) {
        if (buscaAtual === "Entretenimento" && key.startsWith("Criança (0")) {
          babies += passengerObj[key];
        } else {
          childs += passengerObj[key];
        }
      } else if (key.includes("Bebê")) {
        babies += passengerObj[key];
      }
    });

    return { adults, childs, babies };
  };

  useEffect(() => {
    if (user.id) {
      userRepository.getUserDetails(user.id).then((snapshot) => {
        const res = snapshot.docs.map((i) => i.data());
        setUserCardDataSaved(res);
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.id]);

  const getValuesByUser = (val) => {
    let value = signed
      ? val * user.catalog.catalogCurrencyConfig.conversionRate
      : val;

    if (user.campaign) value = addFeeByDestinoFerias(value, buscaAtual);

    return signed ? Math.ceil(Math.round(value)) : value;
  };

  const getValuesByUserWithoutFee = (val) => {
    let value = signed
      ? val * user.catalog.catalogCurrencyConfig.conversionRate
      : val;

    if (buscaAtual === "Hotel" || buscaAtual === "Pacote") {
      return signed ? Math.round(value) : value;
    } else {
      return value;
    }
  };

  useEffect(() => {
    if (buscaAtual === "Aéreo") {
      // let adt = dataSelected?.recommendation.fares.find(
      //   (x) => x.paxtype === 'ADT'
      // )?.fareamount;

      // let chd = dataSelected?.recommendation.fares.find(
      //   (x) => x.paxtype === 'CHD'
      // )?.fareamount;

      // let inf = dataSelected?.recommendation.fares.find(
      //   (x) => x.paxtype === 'INF'
      // )?.fareamount;

      let fee =
        dataSelected?.recommendation.totalfare.totaldu +
        dataSelected?.recommendation.totalfare.totaltaxes;

      // -!isNaN(adt) ? setAdultsTotal(getValuesByUser(adt)) : setAdultsTotal(0);
      // -!isNaN(chd) ? setChildsTotal(getValuesByUser(chd)) : setChildsTotal(0);
      // -!isNaN(inf) ? setBabiesTotal(getValuesByUser(inf)) : setBabiesTotal(0);
      !isNaN(fee) ? setFees(getValuesByUser(fee)) : setFees(0);

      const total = dataSelected?.recommendation.totalfare.total;
      setCashPrice(addFeeByDestinoFerias(total, buscaAtual));
    }

    if (buscaAtual === "Experiencias") {
      let adt = dataSelected?.experience.price;

      // guarda contra qtParticipants nulo/0 (exclusivos novos podem nao ter o campo)
      const qtParticipants = dataSelected?.experience.qtParticipants || 1;
      const total = adt * (dataSelected?.adults / qtParticipants);
      setCashPrice(addFeeByDestinoFerias(total, buscaAtual));
    }

    if (buscaAtual === "Carro") {
      setCashPrice(dataSelected?.cashPrice ?? dataSelected?.totalAmount ?? 0);
    }

    if (buscaAtual === "Hotel") {
      let total = 0;

      if (searchState) {
        // Check if we have multiple rooms selected
        const selectedRoomsData = getSessionStorage("@roomSelected");
        if (
          selectedRoomsData &&
          Array.isArray(selectedRoomsData) &&
          selectedRoomsData.length > 1
        ) {
          // Sum up all room prices for multiple rooms
          total = selectedRoomsData.reduce((sum, room) => {
            return sum + (room.totalTax || 0);
          }, 0);
        } else {
          // Single room calculation (original logic)
          total =
            dataSelected?.rateSelected[
              dataSelected?.rateSelected.total.currencyCode === "BRL"
                ? "total"
                : "origTotal" || "total"
            ].amountAfterTax;
        }
      }

      setCashPrice(total);
    }

    if (buscaAtual === "Rodoviário") {
      setCashPrice(
        addFeeByDestinoFerias(calcBusPointsTotal(dataSelected), buscaAtual),
      );
    }

    if (buscaAtual === "Entretenimento") {
      let total = dataSelected?.data.totalPrice;

      // setCashPrice(addFeeByDestinoFerias(total, buscaAtual));
      setCashPrice(total);
    }

    if (buscaAtual === "Pacote") {
      const packageSelected = getSessionStorage("@PackageSelected");
      if (packageSelected && packageSelected.totalPrice) {
        const total = packageSelected.totalPrice;
        setCashPrice(total);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [buscaAtual, dataSelected]);

  useEffect(() => {
    if (buscaAtual === "Pacote") {
      const handlePackageSelectionChange = () => {
        const packageSelected = getSessionStorage("@PackageSelected");
        if (packageSelected && packageSelected.totalPrice) {
          const total = packageSelected.totalPrice;
          setCashPrice(total);
        }
      };

      window.addEventListener(
        "packageSelectionChanged",
        handlePackageSelectionChange,
      );

      return () => {
        window.removeEventListener(
          "packageSelectionChanged",
          handlePackageSelectionChange,
        );
      };
    }
  }, [buscaAtual]);

  // Minimo de pontos exigido para um dado preco. Extraido do useEffect abaixo
  // para poder ser reaproveitado quando o CheckRate reprecifica a reserva de
  // carro: e este o valor que trava o botao "Comprar", entao qualquer checagem
  // de saldo tem que usar exatamente a mesma regra.
  const calcMinimumPointsToBuy = (price, discCash, campDiscCash) => {
    if (user?.campaign?.acceptCashPayment) {
      //regra sobrescrita pelo campo % pagamento em dinheiro criado no ADM
      return Math.round(
        getValuesByUserWithoutFee(price) -
          discCash -
          campDiscCash -
          Math.ceil(
            getValuesByUserWithoutFee(price - discCash - campDiscCash) *
              (user.campaign.cashPaymentPercentage / 100),
          ),
      );
    }

    return Math.ceil(getValuesByUserWithoutFee(price) * 1);
  };

  useEffect(() => {
    if (
      buscaAtual === "Aéreo" ||
      buscaAtual === "Experiencias" ||
      buscaAtual === "Carro" ||
      buscaAtual === "Hotel" ||
      buscaAtual === "Rodoviário" ||
      buscaAtual === "Entretenimento" ||
      buscaAtual === "Pacote"
    ) {
      setPointsPrice(
        // Math.ceil(
        // Math.round(
        getValuesByUserWithoutFee(cashPrice),
        // )
        // )
      );
      setMinimumPointsToBuy(
        calcMinimumPointsToBuy(cashPrice, discountCash, campaignDiscountCash),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    cashPrice,
    buscaAtual,
    conversionRate,
    discountCash,
    campaignDiscountCash,
  ]);

  const calculateCampaignDiscount = (
    cashPriceLessUserPoints,
    cashPrice,
    pointsPrice,
    pointsTotal,
    cashTotal,
  ) => {
    if (
      !user?.campaign?.disablePointActivity &&
      user?.campaign?.coupon?.discountType === discountTypeEnum.POINTS
    ) {
      cashPriceLessUserPoints = Math.max(
        cashPrice -
          userPoints / conversionRate -
          user.campaign.coupon.value / conversionRate,
        0,
      );
      pointsTotal =
        userPoints <= pointsPrice - user.campaign.coupon.value
          ? // O cupom ja foi abatido de cashPriceLessUserPoints acima. Descontar
            // de novo aqui cobrava o cupom em dobro: o total pago virava
            // P - 2V/cr em vez de P - V/cr, e a diferenca sobrava para a DF.
            Math.max(userPoints, 0)
          : Math.max(pointsPrice - user.campaign.coupon.value, 0);
      cashTotal = parseFloat(
        userPoints <= pointsPrice - user.campaign.coupon.value
          ? cashPriceLessUserPoints
          : 0,
      ).toFixed(2);
      setCampaignDiscountPoints(user.campaign.coupon.value);
      setCashTotalValue(cashTotal);
      setPointsTotalValue(pointsTotal);
      return;
    }

    if (user?.campaign?.coupon?.discountType === discountTypeEnum.PERCENTAGE) {
      let discountValueToBeAppliedTotal =
        cashPrice * (user.campaign.coupon.value / 100);
      let cashPriceWithDiscount = Math.max(
        cashPrice - discountValueToBeAppliedTotal,
        0,
      );

      if (user?.campaign?.disablePointActivity) {
        cashPriceLessUserPoints = Math.max(cashPriceWithDiscount, 0);
        pointsTotal = 0;
        cashTotal = parseFloat(cashPriceLessUserPoints).toFixed(2);
      } else {
        // Comparar contra pointsPrice (sem desconto) fazia o cliente com saldo
        // suficiente pagar o valor cheio em pontos: cashPriceWithDiscount era
        // calculado e descartado, e o desconto da campanha simplesmente nao
        // chegava a ele. O teto em pontos tem que ser o do preco ja com desconto.
        const pointsPriceWithDiscount = getValuesByUserWithoutFee(
          cashPriceWithDiscount,
        );

        cashPriceLessUserPoints = Math.max(
          cashPriceWithDiscount - userPoints / conversionRate,
          0,
        );
        pointsTotal =
          userPoints <= pointsPriceWithDiscount
            ? Math.max(userPoints, 0)
            : Math.max(pointsPriceWithDiscount, 0);
        cashTotal = parseFloat(
          userPoints <= pointsPriceWithDiscount ? cashPriceLessUserPoints : 0,
        ).toFixed(2);
      }

      setCampaignDiscountCash(
        Math.min(discountValueToBeAppliedTotal, cashPrice),
      );
      setDiscountPercentage(user.campaign.coupon.value);
      setCashTotalValue(cashTotal);
      setPointsTotalValue(pointsTotal);
      return;
    }
  };

  useEffect(() => {
    let cashPriceLessUserPoints = user?.campaign?.disablePointActivity
      ? cashPrice
      : Math.max(cashPrice - userPoints / conversionRate, 0);
    let pointsTotal = user?.campaign?.disablePointActivity
      ? 0
      : userPoints <= pointsPrice
      ? userPoints
      : pointsPrice;
    let cashTotal = user?.campaign?.disablePointActivity
      ? parseFloat(cashPriceLessUserPoints).toFixed(2)
      : parseFloat(
          userPoints <= pointsPrice ? cashPriceLessUserPoints : 0,
        ).toFixed(2);

    if (buscaAtual === "Aéreo") {
      if (user?.campaign?.coupon?.air) {
        calculateCampaignDiscount(
          cashPriceLessUserPoints,
          cashPrice,
          pointsPrice,
          pointsTotal,
          cashTotal,
        );
      } else {
        setCashTotalValue(cashTotal);
        setPointsTotalValue(pointsTotal);
      }
    }

    if (buscaAtual === "Experiencias") {
      if (user?.campaign?.coupon?.experience) {
        calculateCampaignDiscount(
          cashPriceLessUserPoints,
          cashPrice,
          pointsPrice,
          pointsTotal,
          cashTotal,
        );
      } else {
        setCashTotalValue(cashTotal);
        setPointsTotalValue(pointsTotal);
      }
    }
    if (buscaAtual === "Carro") {
      if (user?.campaign?.coupon?.car) {
        calculateCampaignDiscount(
          cashPriceLessUserPoints,
          cashPrice,
          pointsPrice,
          pointsTotal,
          cashTotal,
        );
      } else {
        setCashTotalValue(cashTotal);
        setPointsTotalValue(pointsTotal);
      }
    }
    if (buscaAtual === "Hotel") {
      if (user?.campaign?.coupon?.hotel) {
        calculateCampaignDiscount(
          cashPriceLessUserPoints,
          cashPrice,
          pointsPrice,
          pointsTotal,
          cashTotal,
        );
      } else {
        setCashTotalValue(cashTotal);
        setPointsTotalValue(pointsTotal);
      }
    }
    if (buscaAtual === "Rodoviário") {
      if (user?.campaign?.coupon?.bus) {
        calculateCampaignDiscount(
          cashPriceLessUserPoints,
          cashPrice,
          pointsPrice,
          pointsTotal,
          cashTotal,
        );
      } else {
        setCashTotalValue(cashTotal);
        setPointsTotalValue(pointsTotal);
      }
    }
    if (buscaAtual === "Entretenimento") {
      if (user?.campaign?.coupon?.entertainment) {
        calculateCampaignDiscount(
          cashPriceLessUserPoints,
          cashPrice,
          pointsPrice,
          pointsTotal,
          cashTotal,
        );
      } else {
        setCashTotalValue(cashTotal);
        setPointsTotalValue(pointsTotal);
      }
    }
    if (buscaAtual === "Pacote") {
      if (user?.campaign?.coupon?.package) {
        calculateCampaignDiscount(
          cashPriceLessUserPoints,
          cashPrice,
          pointsPrice,
          pointsTotal,
          cashTotal,
        );
      } else {
        setCashTotalValue(cashTotal);
        setPointsTotalValue(pointsTotal);
      }
    }
  }, [
    buscaAtual,
    pointsPrice,
    signed,
    cashPrice,
    user,
    userPoints,
    conversionRate,
  ]);

  const savedCard = (flag = "", lastFourDigits, vaultId) => {
    return (
      <S.CreditCard>
        <span>{flag}</span>
        <span>{` *${lastFourDigits}`}</span>
        <ThemeButton
          onClick={() => {
            setUseSavedCard(!useSavedCard);
            setSend(false);
          }}
          className="reprocessar"
        >
          {useSavedCard ? "Não usar cartão salvo" : "Usar cartão salvo"}
        </ThemeButton>
      </S.CreditCard>
    );
  };

  const castPointsToMoney = (pointsValue) => {
    if (pointsValue < pointsPrice) {
      setPaymentInMoney(
        parseFloat(
          cashPrice -
            pointsValue /
              // - discountPoints
              conversionRate,
        ).toFixed(2),
      );
    }
  };

  const castMoneyToPoints = (moneyValue) => {
    if (moneyValue < cashPrice) {
      setPaymentInPoints(
        parseFloat(
          Math.round(Math.max(pointsPrice - moneyValue * conversionRate, 0)),
        ),
        // -
        //   discountPoints
      );
    }
  };

  const onChangeField = (e) => {
    setState({ ...state, [e.target.name]: e.target.value });
  };

  const onChangeFieldCobranca = (e) => {
    setUserDataAddress({ ...userDataAddress, [e.target.name]: e.target.value });
  };

  const onChangeRoomGuests = (obj) => {
    let quarto = quartos.find((q) => q.quarto === obj.quarto);

    if (obj.prop === "name" || obj.prop === "lastName") {
      const normalizedValue =
        obj.value || (obj.target && obj.target.value) || "";

      const processedValue = normalizedValue
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-zA-Z ]/g, "")
        .toUpperCase();
      obj.value = processedValue;
      if (obj.target && obj.target.value !== undefined) {
        obj.target.value = processedValue;
      }
    }

    if (quarto) {
      let hospede = quarto.hospedes.find((h) => h.hospede === obj.hospede);
      if (hospede) {
        hospede = {
          ...hospede,
          [obj.prop]: obj.value,
          main: obj.quarto === 0 && obj.hospede === 0 ? true : false,
        };
      } else {
        hospede = {
          hospede: obj.hospede,
          [obj.prop]: obj.value,
          main: obj.quarto === 0 && obj.hospede === 0 ? true : false,
        };
      }
      quarto = {
        quarto: obj.quarto,
        hospedes: [
          ...quarto.hospedes.filter((h) => h.hospede !== obj.hospede),
          hospede,
        ],
      };
    } else {
      quarto = {
        quarto: obj.quarto,
        hospedes: [
          {
            hospede: obj.hospede,
            [obj.prop]: obj.value,
            main: obj.quarto === 0 && obj.hospede === 0 ? true : false,
          },
        ],
      };
    }

    setQuartos([...quartos.filter((q) => q.quarto !== quarto.quarto), quarto]);
  };

  const onChangePassengers = (type, index, e) => {
    if (e.target.name === "name" || e.target.name === "lastName") {
      e.target.value = e.target.value
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toUpperCase();
    }

    setState({
      ...state,
      passengers: {
        ...state.passengers,
        [index]: {
          ...state.passengers[index],
          [e.target.name]: e.target.value,
        },
      },
    });
  };

  const mountRoomStaysBooking = () => {
    let roomStays = getSessionStorage("@hotelSelected").roomStays;

    roomStays.roomTypes = [{ ...dataSelected.room }];
    return roomStays;
  };

  useEffect(() => {
    if (dataSelected?.availabilityData?.activityId.startsWith("4")) {
      setActivityCategory("transfer");
    } else if (dataSelected?.availabilityData?.activityId.startsWith("5")) {
      setActivityCategory("ticket");
    } else if (dataSelected?.availabilityData?.activityId.startsWith("6")) {
      setActivityCategory("tour");
    }
  }, [dataSelected]);

  const mountRequest = () => {
    let segments = [];
    if (buscaAtual === "Aéreo") {
      if (returnFlight) {
        segments = [goingFlight, returnFlight];
      } else {
        segments = [goingFlight];
      }
    }

    if (buscaAtual === "Rodoviário") {
      if (returnRoute?.key) {
        segments = [goingRoute, returnRoute];
      } else {
        segments = [goingRoute];
      }
    }
    let type = "";

    let data = {};

    if (buscaAtual === "Aéreo") {
      const customer = {
        ...userDataAddress,
        state: userDataAddress.state.substring(
          0,
          userDataAddress.state.length - 5,
        ),
        ipAddress: ipAddress,
      };
      type = "flight";
      data = {
        flight: {
          qtAdult: searchState?.adultos,
          qtChild: searchState?.criancas,
          qtBaby: searchState?.bebes,
          passengers: passengers.map((pass) => state.passengers[pass.index]),
          segments,
          cashPrice: parseFloat(cashPrice),
          pointsPrice: parseFloat(pointsPrice),
          pointsTotalValue:
            parseFloat(paymentInPoints) + parseFloat(discountPoints),
          cashTotalValue: parseFloat(paymentInMoney + discountCash).toFixed(2),
          paymentData: {
            customer: customer,
            paymentCode: CodeAntiFraud,
            cardInfo:
              state.cardNumber &&
              createCard64(
                state.cardHolder,
                state.cardNumber,
                state.cardExpiration,
                state.cardCCV,
              ),
            installments: state.installments,
            saveCreditCard: false,
          },
        },
      };
    }

    if (buscaAtual === "Experiencias") {
      const customer = {
        ...userDataAddress,
        state: userDataAddress.state.substring(
          0,
          userDataAddress.state.length - 5,
        ),
        ipAddress: ipAddress,
      };
      type = "experience";
      data = {
        experience: {
          qtAdult: dataSelected?.adults,
          qtChild: dataSelected?.childs,
          experienceId: dataSelected?.experience.id,
          experienceDateId: dataSelected?.experienceDate.id,
          refToken: dataSelected?.experience.refToken,
          passengers: passengers.map((pass) => state.passengers[pass.index]),
          cashPrice: parseFloat(cashPrice),
          pointsPrice: parseFloat(pointsPrice),
          pointsTotalValue:
            parseFloat(paymentInPoints) + parseFloat(discountPoints),
          cashTotalValue: parseFloat(paymentInMoney + discountCash).toFixed(2),
          selectedDateFromContinuousExperience:
            dataSelected?.experienceDate?.date,
          paymentData: {
            customer: customer,
            paymentCode: CodeAntiFraud,
            cardInfo:
              state.cardNumber &&
              createCard64(
                state.cardHolder,
                state.cardNumber,
                state.cardExpiration,
                state.cardCCV,
              ),
            installments: state.installments,
            saveCreditCard: false,
          },
        },
      };
    }

    if (buscaAtual === "Hotel") {
      const roomSelected = getSessionStorage("@roomSelected");

      const checkRateRequest = buildCheckRateRequest(
        roomSelected,
        quartos,
        searchState,
      );

      const orinterGuests = buildOrinterGuests(quartos, searchState);

      const occupancyForBooking = buildOccupancyForCheckRate(
        quartos,
        searchState,
      );

      type = "hotel";
      data = {
        checkRateRequest: checkRateRequest,
        occupancy: occupancyForBooking,
        guests: orinterGuests,
        qtRooms: searchState?.qtRooms,
        start: searchState?.datas?.completa?.split(" - ")[0],
        end: searchState?.datas?.completa?.split(" - ")[1],
      };
    }

    if (buscaAtual === "Carro") {
      type = "car";

      const mappedPassengers = passengers.map((pass) => {
        const p = state.passengers[pass.index];
        const birthdateParts = p.birthdate?.split("/");
        const birth = birthdateParts
          ? `${birthdateParts[2]}-${birthdateParts[1]}-${birthdateParts[0]}`
          : "";
        return {
          name: p.name,
          lastName: p.lastName,
          birth,
          type: "ADT",
          documentType: p.documentType,
          documentId: p.documentId ? p.documentId.replace(/\D/g, "") : p.documentId,
          document: {
            type: mapDocumentType(p.documentType || "CPF"),
            number: p.documentId ? formatNumberString(p.documentId) : "",
          },
          email: p.email,
          phone: p.phone,
          gender: p.gender,
        };
      });

      data = {
        checkRateRequest: {
          vehicleKey:
            dataSelected.vehicleKey || dataSelected.fareOptions?.[0]?.key,
          refToken: dataSelected.refToken,
        },
        passengers: mappedPassengers,
        cashPrice: parseFloat(cashPrice),
        pointsPrice: parseFloat(pointsPrice),
        pointsTotalValue:
          parseFloat(paymentInPoints) + parseFloat(discountPoints),
        cashTotalValue: parseFloat(
          parseFloat(paymentInMoney) + discountCash,
        ).toFixed(2),
        paidOnDestination: dataSelected.paidOnDestination ?? null,
      };
    }

    if (buscaAtual === "Rodoviário") {
      type = "bus";

      const mappedPassengers = passengers.map((pass) => {
        const passengerData = state.passengers[pass.index];
        const birthdateParts = passengerData.birthdate?.split("/");
        const birthdate = birthdateParts
          ? `${birthdateParts[2]}-${birthdateParts[1]}-${birthdateParts[0]}`
          : "";
        return {
          firstName: passengerData.name,
          lastName: passengerData.lastName,
          email: passengerData.email,
          birth: birthdate,
          document: {
            number: passengerData?.documentId
              ? formatNumberString(passengerData.documentId)
              : "",
            type: passengerData?.documentType
              ? mapDocumentType(passengerData.documentType)
              : "",
          },
          age: calculateAge(birthdate),
          gender: mapGender(passengerData.gender),
          isMain: pass.index === 0,
        };
      });

      const customer = {
        ...userDataAddress,
        state: userDataAddress.state.substring(
          0,
          userDataAddress.state.length - 5,
        ),
        ipAddress: ipAddress,
      };

      data = {
        cashPrice: parseFloat(cashPrice),
        pointsPrice: parseFloat(pointsPrice),
        pointsTotalValue: parseFloat(
          parseFloat(paymentInPoints) + discountPoints,
        ),
        cashTotalValue: parseFloat(
          parseFloat(paymentInMoney) + discountCash,
        ).toFixed(2),

        services: [
          {
            type: type,
            data: {
              id: result?.booking?.id,
              date: result?.booking?.date,
              occupancy:
                mappedPassengers.length ||
                searchState?.passageiros ||
                result?.booking?.bookingBuses[0]?.names?.length ||
                1,
              passengers: mappedPassengers,
              goingBus: result?.booking?.bookingBuses[0].busList[0].key,
              goingBusRefToken:
                result?.booking?.bookingBuses[0].busList[0].refToken,
              goingSeats: selectedGoingSeats.map((seat) => ({
                seat: seat.toString(),
              })),
              returnBus: returnRoute?.key
                ? result?.booking?.bookingBuses[0].busList[1]?.key
                : null,
              returnBusRefToken: returnRoute?.key
                ? result?.booking?.bookingBuses[0].busList[1]?.refToken
                : null,
              returnSeats: returnRoute?.key
                ? selectedReturnSeats
                  ? selectedReturnSeats.map((seat) => ({
                      seat: seat.toString(),
                    }))
                  : []
                : null,
            },
          },
        ],
        payment: {
          customer: customer,

          paymentCode: CodeAntiFraud,
          cardInfo:
            state.cardNumber &&
            createCard64(
              state.cardHolder,
              state.cardNumber,
              state.cardExpiration,
              state.cardCCV,
            ),
          installments: state.installments,
          saveCreditCard: false,
        },
      };

      return { data, type };
    }

    if (buscaAtual === "Entretenimento") {
      type = "entertainment";

      const mappedPassengers = passengers.map((pass) => {
        const passengerData = state.passengers[pass.index];
        const birthdateParts = passengerData.birthdate?.split("/");
        const birthdate = birthdateParts
          ? `${birthdateParts[2]}-${birthdateParts[1]}-${birthdateParts[0]}`
          : "";
        return {
          firstName: passengerData.name,
          lastName: passengerData.lastName,
          birth: birthdate,
          document: {
            number: passengerData?.documentId
              ? formatNumberString(passengerData.documentId)
              : "",
            type: passengerData?.documentType
              ? mapDocumentType(passengerData.documentType)
              : "",
          },
          gender: passengerData?.gender ? mapGender(passengerData.gender) : "",
          phone: passengerData.phone,
          email: passengerData.email,
          isMain: pass.index === 0,
        };
      });

      const customer = {
        ...userDataAddress,
        state: userDataAddress.state.substring(
          0,
          userDataAddress.state.length - 5,
        ),
        ipAddress: ipAddress,
      };

      data = {
        cashPrice: parseFloat(cashPrice),
        pointsPrice: parseFloat(pointsPrice),
        pointsTotalValue: parseFloat(
          parseFloat(paymentInPoints) + discountPoints,
        ),
        cashTotalValue: parseFloat(
          parseFloat(paymentInMoney) + discountCash,
        ).toFixed(2),

        services: [
          {
            type: type,
            data: {
              serviceId: dataSelected.availabilityData.serviceId,
              refToken: dataSelected.availabilityData.refToken,
              refTokenAdditionalInfo:
                dataSelected.availabilityData.refTokenAdditionalInfo,
              startingTime: dataSelected.availabilityData.startingTimes[0]
                ? dataSelected.availabilityData.startingTimes[0]
                : null,
              passengers: mappedPassengers,
            },
          },
        ],
        payment: {
          customer: customer,
          paymentCode: CodeAntiFraud,
          cardInfo:
            state.cardNumber &&
            createCard64(
              state.cardHolder,
              state.cardNumber,
              state.cardExpiration,
              state.cardCCV,
            ),
          installments: state.installments,
          saveCreditCard: false,
        },
      };

      return { data, type };
    }

    if (buscaAtual === "Pacote") {
      type = "package";
      const { adults, children } = passengers.reduce(
        (acc, pass) => {
          const passengerData = state.passengers[pass.index];
          const birthdateParts = passengerData.birthdate?.split("/");
          const birthdate = birthdateParts
            ? `${birthdateParts[2]}-${birthdateParts[1]}-${birthdateParts[0]}`
            : "";

          const age = calculateAge(birthdate);
          const passenger = {
            firstName: passengerData.name,
            lastName: passengerData.lastName,
            email: passengerData.email,
            birth: birthdate,
            document: {
              number: passengerData?.documentId
                ? formatNumberString(passengerData.documentId)
                : "",
              type: passengerData?.documentType
                ? mapDocumentType(passengerData.documentType)
                : "",
            },
            age: calculateAge(birthdate),
            gender: mapGender(passengerData.gender),
            isMain: pass.index === 0,
          };

          if (age >= 18) {
            acc.adults.push({ ...passenger, isMain: pass.index === 0 });
          } else {
            acc.children.push(passenger);
          }

          return acc;
        },
        { adults: [], children: [] },
      );
      const packageAvailResponse = getSessionStorage("@PackageAvailResponse");
      const selectedRoom = getSessionStorage("@PackageSelected");

      data = {
        filter: {
          occupancy: [
            {
              adults,
              children,
            },
          ],
          packageAvails: [
            {
              ...packageAvailResponse.data.packageAvails[0],
              hotelAvails: [
                {
                  ...packageAvailResponse.data.packageAvails[0].hotelAvails[0],
                  roomGroups: [
                    {
                      rooms: [
                        packageAvailResponse.data.packageAvails[0].hotelAvails[0].roomGroups[0].rooms.find(
                          (room, i) => i === selectedRoom.roomIndex,
                        ),
                      ],
                    },
                  ],
                },
              ],
            },
          ],
          refTokenAvailsHotel: packageAvailResponse.data.refTokenAvailsHotel,
          refTokenAvailsFlight: packageAvailResponse.data.refTokenAvailsFlight,
          refTokenAvailsTransfer:
            packageAvailResponse.data.refTokenAvailsTransfer,
          refTokenAvailsServicePackage:
            packageAvailResponse.data.refTokenAvailsServicePackage,
          refTokenAvailsPackage:
            packageAvailResponse.data.refTokenAvailsPackage,
        },
      };
    }
    return { data, type };
  };

  useEffect(() => {
    if (buscaAtual === "Rodoviário" && dataSelected) {
      let isMounted = true;
      setLoadingSeats(true);

      const handleResponse = (response) => {
        if (isMounted) {
          setResult(response.data);

          const bookingBuses = response.data.booking.bookingBuses[0];
          if (bookingBuses.busList[0]?.segments?.length > 0) {
            setSeatMapIda(bookingBuses.busList[0].segments[0].seatMap);
          }
          if (bookingBuses.busList[1]?.segments?.length > 0) {
            setSeatMapVolta(bookingBuses.busList[1].segments[0].seatMap);
          }
          setPolicies(mapBusPolicies(bookingBuses));
          setLoadingSeats(false);
        }
      };

      const handleSubmit = async () => {
        const postData = buildBusCheckRateRequest(dataSelected, searchState);

        try {
          const response = await busRepository.checkBusRate(postData);
          handleResponse(response);

          if (response.data?.filter?.goingBusRefToken) {
            dataSelected.selectedDepart.refToken =
              response.data.filter.goingBusRefToken;
          }
          if (response.data?.filter?.returnBusRefToken) {
            dataSelected.selectedReturn.refToken =
              response.data.filter.returnBusRefToken;
          }
        } catch (error) {
          if (isMounted) {
            setError(
              error.response ? error.response.data : "An error occurred",
            );
          }
        }
      };

      handleSubmit();

      return () => {
        isMounted = false;
      };
    }
  }, [dataSelected]);

  const calculateAge = (birthdate) => {
    const today = new Date();
    const birthDate = new Date(birthdate);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();

    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age;
  };

  const formatNumberString = (numberString) => {
    return numberString.replace(/\D/g, "");
  };

  const mapGender = (gender) => {
    switch (gender) {
      case "M":
        return "MALE";
      case "F":
        return "FEMALE";
      case "O":
        return "OTHER";
      default:
        return "";
    }
  };

  const mapDocumentType = (type) => {
    switch (type) {
      case "CNH":
        return "DRIVER_LICENSE";
      default:
        return type;
    }
  };

  const validateCoupon = async (coupon) => {
    setCouponError("");
    if (discountPoints || discountCash) {
      setCouponError(
        "Já existe um cupom aplicado, remova-o para adicionar um novo!",
      );

      setIsGeneralLoading(false);
      setLoading(false);
      setOpenLoader(false);
    } else {
      const isFromHub =
        buscaAtual === "Rodoviário" ||
        buscaAtual === "Entretenimento" ||
        buscaAtual === "Pacote" ||
        buscaAtual === "Hotel" ||
        buscaAtual === "Carro";

      if (isFromHub) {
        const { data, type } = mountRequest();

        discountRepository
          .validateDiscount(type, { ...data, couponCode: coupon })
          .then((res) => {
            if (
              res.data.couponCode?.coupon?.discountType ===
              discountTypeEnum.PERCENTAGE
            ) {
              setCouponDiscountPercentage(res.data.couponCode?.coupon?.value);
              setDiscountPercentage(
                discountPercentage + res.data.couponCode?.coupon?.value,
              );
            }

            setPaymentInPoints(
              Math.round(paymentInPoints - res.data.discountPoints),
            );
            setPaymentInMoney(
              parseFloat(
                parseFloat(paymentInMoney) - parseFloat(res.data.discountCash),
              ).toFixed(2),
            );
            setDiscountPoints(res.data.discountPoints);
            setDiscountCash(res.data.discountCash);
            setDiscountCoupon(coupon);
            setIsGeneralLoading(false);
            setLoading(false);
            setOpenLoader(false);
          })
          .catch((err) => {
            setCouponError(err?.response?.data?.error);
            setIsGeneralLoading(false);
            setLoading(false);
            setOpenLoader(false);
          });
      } else {
        let { data } = mountRequest();

        bookingsRepository
          .validateDiscount({ ...data, coupon })
          .then((res) => {
            if (
              res.data.couponCode?.coupon?.discountType ===
              discountTypeEnum.PERCENTAGE
            ) {
              setCouponDiscountPercentage(res.data.couponCode?.coupon?.value);
              setDiscountPercentage(
                discountPercentage + res.data.couponCode?.coupon?.value,
              );
            }

            setPaymentInPoints(
              Math.round(paymentInPoints - res.data.discountPoints),
            );
            setPaymentInMoney(
              parseFloat(
                parseFloat(paymentInMoney) - parseFloat(res.data.discountCash),
              ).toFixed(2),
            );
            setDiscountPoints(res.data.discountPoints);
            setDiscountCash(res.data.discountCash);
            setDiscountCoupon(coupon);
            setIsGeneralLoading(false);
            setLoading(false);
            setOpenLoader(false);
          })
          .catch((err) => {
            setCouponError(err?.response?.data?.error);
            setIsGeneralLoading(false);
            setLoading(false);
            setOpenLoader(false);
          });
      }
    }
  };

  const removeCoupon = () => {
    setPaymentInPoints(
      Math.round(parseFloat(paymentInPoints) + parseFloat(discountPoints)),
    );
    setPaymentInMoney(
      parseFloat(parseFloat(paymentInMoney) + parseFloat(discountCash)).toFixed(
        2,
      ),
    );
    setDiscountCoupon("");
    setDiscountPoints(0);
    setDiscountPercentage(discountPercentage - couponDiscountPercentage);
    setCouponDiscountPercentage(0);
    setDiscountCash(0);
    setCouponError("");
  };

  const onSubmit = async () => {
    const hasTheSameNameAndLastName =
      verifyIfAnyGuestOrPassangerHaveTheSameNameAndLastName();
    const hasDuplicateDocs = verifyDuplicateDocuments();
    const childAgeError = verifyChildAges();
    const invalidCpfDocument = hasInvalidCpfDocument();

    const isFromHub =
      buscaAtual === "Rodoviário" ||
      buscaAtual === "Entretenimento" ||
      buscaAtual === "Pacote" ||
      buscaAtual === "Hotel" ||
      buscaAtual === "Carro";

    setLoading(true);
    setOpenLoader(true);
    await setTimeout(function () {}, 4000);

    const helperTexts = document.getElementsByClassName(
      "MuiFormHelperText-root",
    );

    if (helperTexts.length > 0) {
      setLoading(false);
      setOpenLoader(false);

      return showAlert("error", "Preencha todos os campos");
    }
    if (hasTheSameNameAndLastName) {
      setLoading(false);
      setOpenLoader(false);

      return showAlert(
        "error",
        `${
          buscaAtual === "Hotel" ? "Hóspedes" : "Passageiros"
        } com o mesmo nome e sobrenome não são permitidos!`,
      );
    }
    if (hasDuplicateDocs) {
      setLoading(false);
      setOpenLoader(false);

      return showAlert(
        "error",
        "Não é permitido informar o mesmo número de documento para hóspedes diferentes!",
      );
    }
    if (childAgeError) {
      setLoading(false);
      setOpenLoader(false);

      return showAlert(
        "error",
        `A data de nascimento da criança no Quarto ${childAgeError.roomNumber} não corresponde à idade informada na busca. Idade esperada: ${childAgeError.expected} ano(s). Idade calculada: ${childAgeError.actual} ano(s).`,
      );
    }
    if (invalidCpfDocument) {
      setLoading(false);
      setOpenLoader(false);
      return showAlert("error", "Informe um CPF válido para todos os passageiros.");
    }
    if (
      !hasTheSameNameAndLastName &&
      !hasDuplicateDocs &&
      !childAgeError &&
      !invalidCpfDocument &&
      !isFromHub
    ) {
      const { data, type } = mountRequest();
      await bookingsRepository
        .postBooking({
          ...data,
          coupon: discountPoints || discountCash ? discountCoupon : undefined,
        })
        .then((res) => {
          setError("");

          sessionStorage.setItem("@bookingCompleted", JSON.stringify(res));

          switch (res.status) {
            case 200:
              sessionStorage.removeItem("ltnSession");
              login();
              history.push("/busca/finalizado");
              break;

            case 201:
              if (res.data.auth2fa) {
                if (res.data.redirectAuth2fa !== null) {
                  sessionStorage.removeItem("ltnSession");
                  setOpenLoader(true);
                  login();
                  window.location.replace(res.data.redirectAuth2fa);
                } else {
                  setBookingSuccessCode(res);
                  setPaymentData(data[type].paymentData);
                  setOpenModal2fa(true);
                }
              } else {
                sessionStorage.removeItem("ltnSession");
                login();
                history.push("/busca/finalizado");
              }
              break;

            default:
              break;
          }
          setLoading(false);
          setOpenLoader(false);
        })
        .catch((err) => {
          setLoading(false);
          setOpenLoader(false);

          switch (err?.response?.status) {
            case 400:
              sessionStorage.removeItem("ltnSession");
              setError(getCheckoutErrorMessage(err));
              break;
            case 401:
              sessionStorage.removeItem("ltnSession");
              history.push("/session-expires");
              break;
            case 409:
              sessionStorage.removeItem("ltnSession");
              sessionStorage.setItem(
                "@bookingError",
                JSON.stringify(err.response.data.error),
              );
              sessionStorage.setItem(
                "reprocessar",
                JSON.stringify({ reprocessar: false }),
              );
              history.push("/busca/booking-error");
              break;
            case 504:
              sessionStorage.removeItem("ltnSession");
              sessionStorage.setItem(
                "@bookingError",
                JSON.stringify("Tempo expirou, tente novamente!"),
              );
              sessionStorage.setItem(
                "reprocessar",
                JSON.stringify({ reprocessar: false }),
              );
              history.push("/busca/booking-error");
              break;
            default:
              sessionStorage.removeItem("ltnSession");
              setError(`Ocorreu algum problema, por favor, tente novamente!`);
              break;
          }
        });
    } else if (isFromHub) {
      const { data, type } = mountRequest();

      if (type === "hotel") {
        try {
          setLoading(true);
          let isSuccessful = false;
          let bookingData = null;
          const hotelRepository = new HotelRepository();
          await hotelRepository
            .checkRate(data.checkRateRequest)
            .then((res) => {
              setError("");
              switch (res.status) {
                case 200:
                  bookingData = res.data;
                  isSuccessful = true;
                  break;
                default:
                  break;
              }
            })
            .catch((err) => {
              setLoading(false);
              setOpenLoader(false);

              const action = mapHotelCheckRateError(
                err?.response?.status,
                err?.response?.data?.error,
              );
              if (action.bookingError) {
                sessionStorage.setItem(
                  "@bookingError",
                  JSON.stringify(action.bookingError),
                );
                sessionStorage.setItem(
                  "reprocessar",
                  JSON.stringify({ reprocessar: false }),
                );
              }
              if (action.redirect) history.push(action.redirect);
              if (action.error) setError(action.error);
            });
          if (isSuccessful) {
            const checkRateData = bookingData.data || bookingData;
            const searchHotelData = getSessionStorage("@roomSelected");
            const searchHotel = Array.isArray(searchHotelData)
              ? searchHotelData[0]?.hotel
              : searchHotelData?.hotel;
            const getHotelImages = (hotel) => {
              if (!hotel) return undefined;
              if (hotel.images?.length > 0) return hotel.images;
              if (hotel.details?.images?.length > 0)
                return hotel.details.images;
              const imageItems =
                hotel.hotelDescriptiveContent?.hotelInfo?.descriptions
                  ?.multimediaDescriptionsType?.multimediaDescriptions?.[0]
                  ?.imageItemsType?.imageItems;
              if (imageItems?.length > 0) {
                return imageItems.map((img) => ({
                  large: img.url?.address,
                  medium: img.url?.address,
                  small: img.url?.address,
                }));
              }
              return undefined;
            };
            const hotelWithImages = {
              ...checkRateData.hotel,
              images:
                checkRateData.hotel?.images || getHotelImages(searchHotel),
            };
            await hotelRepository
              .booking({
                data: {
                  cashPrice: checkRateData.cashPrice,
                  pointsPrice: checkRateData.pointsPrice,
                  pointsTotalValue: parseFloat(
                    parseFloat(paymentInPoints) + discountPoints,
                  ),
                  cashTotalValue: parseFloat(
                    parseFloat(paymentInMoney) + discountCash,
                  ).toFixed(2),
                  services: [
                    {
                      type: "hotel",
                      data: {
                        bookingId: checkRateData.bookingId,
                        expirationDate: checkRateData.expirationDate,
                        bookingAmount: checkRateData.bookingAmount,
                        hotel: hotelWithImages,
                        rooms: checkRateData.rooms,
                        refToken: checkRateData.refToken,
                        occupancy: data.occupancy,
                        guests: data.guests,
                        qtRooms: data.qtRooms,
                      },
                    },
                  ],
                  payments: [
                    {
                      customer: {
                        ...userDataAddress,
                        state: userDataAddress.state.substring(
                          0,
                          userDataAddress.state.length - 5,
                        ),
                        ipAddress: ipAddress,
                      },

                      paymentCode: CodeAntiFraud,
                      cardInfo:
                        state.cardNumber &&
                        createCard64(
                          state.cardHolder,
                          state.cardNumber,
                          state.cardExpiration,
                          state.cardCCV,
                        ),
                      installments: state.installments,
                      saveCreditCard: false,
                    },
                  ],
                },
              })
              .then((res) => {
                setError("");
                setLoading(false);
                setOpenLoader(false);
                sessionStorage.setItem(
                  "@bookingCompleted",
                  JSON.stringify(res),
                );

                switch (res.status) {
                  case 200:
                    login();
                    history.push("/busca/finalizado");
                    break;

                  case 201:
                    if (res.data.auth2fa) {
                      if (res.data.redirectAuth2fa !== null) {
                        setOpenLoader(true);
                        login();
                        window.location.replace(res.data.redirectAuth2fa);
                      } else {
                        setBookingSuccessCode(res);
                        setPaymentData(data[type].paymentData);
                        setOpenModal2fa(true);
                      }
                    } else {
                      login();
                      history.push("/busca/finalizado");
                    }
                    break;

                  case 202:
                    sessionStorage.removeItem("ltnSession");
                    // Demanda 240 — HTTP 202 não é venda: o grupo do status no fornecedor
                    // decide qual mensagem a tela de processamento mostra.
                    sessionStorage.setItem("@booking-processing-group", res?.data?.statusGroup || "EM_ANDAMENTO");
                    login();
                    history.push("/busca/processando");
                    break;
                  default:
                    break;
                }
              })
              .catch((err) => {
                setLoading(false);
                setOpenLoader(false);

                switch (err?.response?.status) {
                  case 400:
                    setError(getCheckoutErrorMessage(err));
                    break;
                  case 401:
                    history.push("/session-expires");
                    break;
                  case 409:
                    sessionStorage.setItem(
                      "@bookingError",
                      JSON.stringify(err.response.data.error),
                    );
                    sessionStorage.setItem(
                      "reprocessar",
                      JSON.stringify({ reprocessar: false }),
                    );
                    history.push("/busca/booking-error");
                    break;
                  case 504:
                    sessionStorage.setItem(
                      "@bookingError",
                      JSON.stringify("Tempo expirou, tente novamente!"),
                    );
                    sessionStorage.setItem(
                      "reprocessar",
                      JSON.stringify({ reprocessar: false }),
                    );
                    history.push("/busca/booking-error");
                    break;
                  default:
                    setError(
                      `Ocorreu algum problema, por favor, tente novamente!`,
                    );
                    break;
                }
              });
          }
        } catch (error) {
          setLoading(false);
          setOpenLoader(false);
          console.error(error);
        }
      }

      if (type === "package") {
        try {
          setLoading(true);
          let isSuccessful = false;
          let bookingData = null;
          const packageRepository = new PackageRepository();
          await packageRepository
            .packageCheckRate(data)
            .then((res) => {
              setError("");
              switch (res.status) {
                case 200:
                  bookingData = res.data;
                  isSuccessful = true;
                  break;
                default:
                  break;
              }
            })
            .catch((err) => {
              setLoading(false);
              setOpenLoader(false);

              switch (err?.response?.status) {
                case 400:
                  history.push("/busca/pacote-indisponivel");
                  break;
                case 401:
                  history.push("/session-expires");
                  break;
                case 409:
                  sessionStorage.setItem(
                    "@bookingError",
                    JSON.stringify(err.response.data.error),
                  );
                  sessionStorage.setItem(
                    "reprocessar",
                    JSON.stringify({ reprocessar: false }),
                  );
                  history.push("/busca/booking-error");
                  break;
                case 504:
                  sessionStorage.setItem(
                    "@bookingError",
                    JSON.stringify("Tempo expirou, tente novamente!"),
                  );
                  sessionStorage.setItem(
                    "reprocessar",
                    JSON.stringify({ reprocessar: false }),
                  );
                  history.push("/busca/booking-error");
                  break;
                default:
                  setError(
                    `Ocorreu algum problema, por favor, tente novamente!`,
                  );
                  break;
              }
            });
          if (isSuccessful) {
            await packageRepository
              .packageBooking({
                data: {
                  pointsTotalValue: parseFloat(
                    parseFloat(paymentInPoints) + discountPoints,
                  ),
                  cashTotalValue: parseFloat(
                    parseFloat(paymentInMoney) + discountCash,
                  ).toFixed(2),
                  ...bookingData.data,
                  // o check-rate devolve a ocupacao sem os documentos; mantem a do formulario
                  services: bookingData.data.services?.map((service) => ({
                    ...service,
                    data: {
                      ...service.data,
                      occupancy: data.filter.occupancy,
                    },
                  })),
                  bookingTransfers: bookingData.data.bookingTransfers?.map((bt) => ({
                    ...bt,
                    transfer: {
                      ...bt.transfer,
                      description: bt.transfer?.description?.replace(/[\r\n\t]/g, ' '),
                    },
                  })),
                  orinterPayment: bookingData.data.orinterPayment[0],
                  payments: [
                    {
                      customer: {
                        ...userDataAddress,
                        state: userDataAddress.state.substring(
                          0,
                          userDataAddress.state.length - 5,
                        ),
                        ipAddress: ipAddress,
                      },

                      paymentCode: CodeAntiFraud,
                      cardInfo:
                        state.cardNumber &&
                        createCard64(
                          state.cardHolder,
                          state.cardNumber,
                          state.cardExpiration,
                          state.cardCCV,
                        ),
                      installments: state.installments,
                      saveCreditCard: false,
                    },
                  ],
                },
              })
              .then((res) => {
                setError("");
                setLoading(false);
                setOpenLoader(false);
                sessionStorage.setItem(
                  "@bookingCompleted",
                  JSON.stringify(res),
                );

                switch (res.status) {
                  case 200:
                    login();
                    history.push("/busca/finalizado");
                    break;

                  case 201:
                    if (res.data.auth2fa) {
                      if (res.data.redirectAuth2fa !== null) {
                        setOpenLoader(true);
                        login();
                        window.location.replace(res.data.redirectAuth2fa);
                      } else {
                        setBookingSuccessCode(res);
                        setPaymentData(data[type].paymentData);
                        setOpenModal2fa(true);
                      }
                    } else {
                      login();
                      history.push("/busca/finalizado");
                    }
                    break;

                  case 202:
                    sessionStorage.removeItem("ltnSession");
                    // Demanda 240 — HTTP 202 não é venda: o grupo do status no fornecedor
                    // decide qual mensagem a tela de processamento mostra.
                    sessionStorage.setItem("@booking-processing-group", res?.data?.statusGroup || "EM_ANDAMENTO");
                    login();
                    history.push("/busca/processando");
                    break;

                  default:
                    break;
                }
              })
              .catch((err) => {
                setLoading(false);
                setOpenLoader(false);

                switch (err?.response?.status) {
                  case 400:
                    setError(getCheckoutErrorMessage(err));
                    break;
                  case 401:
                    history.push("/session-expires");
                    break;
                  case 409:
                    sessionStorage.setItem(
                      "@bookingError",
                      JSON.stringify(err.response.data.error),
                    );
                    sessionStorage.setItem(
                      "reprocessar",
                      JSON.stringify({ reprocessar: false }),
                    );
                    history.push("/busca/booking-error");
                    break;
                  case 504:
                    sessionStorage.setItem(
                      "@bookingError",
                      JSON.stringify("Tempo expirou, tente novamente!"),
                    );
                    sessionStorage.setItem(
                      "reprocessar",
                      JSON.stringify({ reprocessar: false }),
                    );
                    history.push("/busca/booking-error");
                    break;
                  default:
                    setError(
                      `Ocorreu algum problema, por favor, tente novamente!`,
                    );
                    break;
                }
              });
          }
        } catch (error) {
          setLoading(false);
          console.error(error);
        }
      }

      if (type === "car") {
        try {
          setLoading(true);
          let isSuccessful = false;
          let bookingData = null;
          const carRepository = new CarRepository();
          await carRepository
            .checkRate(data.checkRateRequest)
            .then((res) => {
              setError("");
              switch (res.status) {
                case 200:
                  bookingData = res.data;
                  isSuccessful = true;
                  break;
                default:
                  break;
              }
            })
            .catch((err) => {
              setLoading(false);
              setOpenLoader(false);

              switch (err?.response?.status) {
                case 400:
                  setError(getCheckoutErrorMessage(err));
                  break;
                case 401:
                  history.push("/session-expires");
                  break;
                case 409:
                  sessionStorage.setItem(
                    "@bookingError",
                    JSON.stringify(err.response.data.error),
                  );
                  sessionStorage.setItem(
                    "reprocessar",
                    JSON.stringify({ reprocessar: false }),
                  );
                  history.push("/busca/booking-error");
                  break;
                case 504:
                  sessionStorage.setItem(
                    "@bookingError",
                    JSON.stringify("Tempo expirou, tente novamente!"),
                  );
                  sessionStorage.setItem(
                    "reprocessar",
                    JSON.stringify({ reprocessar: false }),
                  );
                  history.push("/busca/booking-error");
                  break;
                default:
                  setError(
                    `Ocorreu algum problema, por favor, tente novamente!`,
                  );
                  break;
              }
            });

          if (isSuccessful) {
            const checkRateData = bookingData.data || bookingData;
            const serviceData = checkRateData.services[0].data;

            // A tarifa da Availability pode estar defasada; o CheckRate traz o
            // preco real do fornecedor (e o refToken que o backend valida).
            // Reprecifica o resumo aqui para nao cobrar do cliente um valor e
            // reservar no fornecedor por outro: cashPrice realimenta
            // pointsPrice -> cashTotalValue/pointsTotalValue antes do aceite
            // das politicas, que e o que handleCarPoliciesAccept envia.
            const checkRatePrice = Number(checkRateData.cashPrice);
            const availabilityPrice = Number(cashPrice);
            const priceChanged =
              !isNaN(checkRatePrice) &&
              checkRatePrice > 0 &&
              Math.abs(checkRatePrice - availabilityPrice) >= 0.01;

            if (priceChanged) {
              const newPriceFormatted = checkRatePrice.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              });

              setCashPrice(checkRatePrice);

              // O cupom foi validado contra o preco antigo e o desconto vive em
              // paymentInPoints/paymentInMoney, que a cadeia de effects de
              // cashPrice sobrescreve com os valores brutos. Seguir daqui
              // enviaria bruto + discount* no payload (cliente perde o desconto
              // ou paga a mais), e um cupom percentual valeria menos do que
              // deveria sobre o preco novo. Entao zera o cupom e devolve o
              // controle: o cliente reaplica sobre o valor correto.
              if (discountCoupon || discountPoints || discountCash) {
                setDiscountCoupon("");
                setDiscountPoints(0);
                setDiscountCash(0);
                setDiscountPercentage(
                  discountPercentage - couponDiscountPercentage,
                );
                setCouponDiscountPercentage(0);
                setCouponError("");
                setCarPriceUpdate(null);
                setLoading(false);
                setOpenLoader(false);
                return showAlert(
                  "warning",
                  `O fornecedor atualizou o valor desta reserva para ${newPriceFormatted}. Seu cupom foi removido porque o desconto seria calculado sobre o valor antigo — aplique-o novamente e confirme a compra.`,
                );
              }

              // Mesma regra que trava o botao "Comprar": o minimo de pontos
              // sobe junto com o preco, entao um saldo que bastava antes pode
              // nao bastar agora.
              const newMinimumPointsToBuy = calcMinimumPointsToBuy(
                checkRatePrice,
                0,
                campaignDiscountCash,
              );

              if (signed && userPoints < newMinimumPointsToBuy) {
                setCarPriceUpdate(null);
                setLoading(false);
                setOpenLoader(false);
                return showAlert(
                  "error",
                  `O fornecedor atualizou o valor desta reserva para ${newPriceFormatted} e seu saldo não é suficiente para concluí-la. Escolha outro veículo.`,
                );
              }

              setCarPriceUpdate({
                from: availabilityPrice,
                to: checkRatePrice,
              });
            } else {
              setCarPriceUpdate(null);
            }

            setCarPoliciesData({
              policies: serviceData.policies || [],
              cancellationPolicies: serviceData.cancellationPolicies || null,
            });
            setPendingCarBooking({ checkRateData, data });
            setOpenCarPoliciesModal(true);
            setLoading(false);
            setOpenLoader(false);
          }
        } catch (error) {
          setLoading(false);
          setOpenLoader(false);
          console.error(error);
        }
      }

      if (type === "bus") {
        await busRepository
          .postBusBooking({
            ...data,
            coupon: discountPoints || discountCash ? discountCoupon : undefined,
          })
          .then((res) => {
            setError("");
            setLoading(false);
            setOpenLoader(false);
            sessionStorage.setItem("@bookingCompleted", JSON.stringify(res));

            switch (res.status) {
              case 200:
                login();
                history.push("/busca/finalizado");
                break;

              case 201:
                if (res.data.auth2fa) {
                  if (res.data.redirectAuth2fa !== null) {
                    setOpenLoader(true);
                    login();
                    window.location.replace(res.data.redirectAuth2fa);
                  } else {
                    setBookingSuccessCode(res);
                    setPaymentData(data[type].paymentData);
                    setOpenModal2fa(true);
                  }
                } else {
                  login();
                  history.push("/busca/finalizado");
                }
                break;
              case 202:
                // Demanda 240 - HTTP 202 nao e venda: o grupo do status no fornecedor
                // decide qual mensagem a tela de processamento mostra.
                sessionStorage.setItem("@booking-processing-group", res?.data?.statusGroup || "EM_ANDAMENTO");
                login();
                history.push("/busca/processando");
                break;

              default:
                break;
            }
          })
          .catch((err) => {
            setLoading(false);
            setOpenLoader(false);

            switch (err?.response?.status) {
              case 400:
                setError(getCheckoutErrorMessage(err));
                break;
              case 401:
                history.push("/session-expires");
                break;
              case 409:
                sessionStorage.setItem(
                  "@bookingError",
                  JSON.stringify(err.response.data.error),
                );
                sessionStorage.setItem(
                  "reprocessar",
                  JSON.stringify({ reprocessar: false }),
                );
                history.push("/busca/booking-error");
                break;
              case 504:
                sessionStorage.setItem(
                  "@bookingError",
                  JSON.stringify("Tempo expirou, tente novamente!"),
                );
                sessionStorage.setItem(
                  "reprocessar",
                  JSON.stringify({ reprocessar: false }),
                );
                history.push("/busca/booking-error");
                break;
              default:
                setError(`Ocorreu algum problema, por favor, tente novamente!`);
                break;
            }
          });
      }
      if (type === "entertainment") {
        var bookingData = {};

        if (activityCategory === "transfer") {
          bookingData = {
            ...data,
            coupon: discountPoints || discountCash ? discountCoupon : undefined,
            transferData: transferData,
          };
        } else {
          bookingData = {
            ...data,
            coupon: discountPoints || discountCash ? discountCoupon : undefined,
          };
        }

        await entertainmentRepository
          .createBooking({ data: bookingData })
          .then((res) => {
            setError("");
            setLoading(false);
            setOpenLoader(false);
            sessionStorage.setItem(
              "@bookingCompleted",
              JSON.stringify(res.data),
            );

            switch (res.status) {
              case 200:
                login();
                history.push("/busca/finalizado");
                break;

              case 201:
                if (res.data.auth2fa) {
                  if (res.data.redirectAuth2fa !== null) {
                    setOpenLoader(true);
                    login();
                    window.location.replace(res.data.redirectAuth2fa);
                  } else {
                    setBookingSuccessCode(res);
                    setPaymentData(data[type].paymentData);
                    setOpenModal2fa(true);
                  }
                } else {
                  login();
                  history.push("/busca/finalizado");
                }
                break;
              default:
                break;
            }
          })
          .catch((err) => {
            setLoading(false);
            setOpenLoader(false);

            switch (err?.response?.status) {
              case 400:
                setError(getCheckoutErrorMessage(err));
                break;
              case 401:
                history.push("/session-expires");
                break;
              case 409:
                sessionStorage.setItem(
                  "@bookingError",
                  JSON.stringify(err.response.data.error),
                );
                sessionStorage.setItem(
                  "reprocessar",
                  JSON.stringify({ reprocessar: false }),
                );
                history.push("/busca/booking-error");
                break;
              case 500:
                sessionStorage.setItem(
                  "@bookingError",
                  JSON.stringify(err.response.data.error),
                );
                break;
              case 504:
                sessionStorage.setItem(
                  "@bookingError",
                  JSON.stringify("Tempo expirou, tente novamente!"),
                );
                sessionStorage.setItem(
                  "reprocessar",
                  JSON.stringify({ reprocessar: false }),
                );
                history.push("/busca/booking-error");
                break;
              default:
                setError(`Ocorreu algum problema, por favor, tente novamente!`);
                break;
            }
          });
      }
    }
  };
  useEffect(() => {
    setInstallmentsNumber(
      Array.from(
        { length: MAX_INSTALLMENTS },
        // { length: signed ? user.catalog.maximumInstallments : 10 },
        (_, i) => i + 1,
      ),
    );
  }, [signed, user]);

  useEffect(() => {
    cashTotalValue ? setPaymentInMoney(cashTotalValue) : setPaymentInMoney(0);
    pointsTotalValue
      ? setPaymentInPoints(Math.round(pointsTotalValue))
      : setPaymentInPoints(0);
  }, [pointsTotalValue, cashTotalValue]);

  const closeModal2fa = () => setOpenModal2fa(false);

  const handleCarPoliciesDecline = () => {
    setOpenCarPoliciesModal(false);
    setPendingCarBooking(null);
    setCarPriceUpdate(null);
    setCarPoliciesData({ policies: [], cancellationPolicies: null });
  };

  const handleCarPoliciesAccept = async () => {
    if (!pendingCarBooking) return;
    const { checkRateData, data } = pendingCarBooking;
    setOpenCarPoliciesModal(false);
    setPendingCarBooking(null);
    setCarPriceUpdate(null);
    setLoading(true);
    setOpenLoader(true);

    const carRepository = new CarRepository();
    await carRepository
      .booking({
        data: {
          cashPrice: checkRateData.cashPrice,
          pointsPrice: checkRateData.pointsPrice,
          pointsTotalValue:
            parseFloat(paymentInPoints) + parseFloat(discountPoints),
          cashTotalValue: (
            parseFloat(paymentInMoney) + parseFloat(discountCash)
          ).toFixed(2),
          coupon:
            discountPoints || discountCash ? discountCoupon : undefined,
          services: [
            {
              type: "car",
              data: {
                ...checkRateData.services[0].data,
                passengers: data.passengers,
                paidOnDestination:
                  dataSelected.paidOnDestination ?? null,
                fareOptions: dataSelected.fareOptions ?? null,
              },
            },
          ],
          orinterPayment: checkRateData.orinterPayment,
          payments: [
            {
              customer: {
                ...userDataAddress,
                state: userDataAddress.state.substring(
                  0,
                  userDataAddress.state.length - 5,
                ),
                ipAddress: ipAddress,
              },
              paymentCode: CodeAntiFraud,
              cardInfo:
                state.cardNumber &&
                createCard64(
                  state.cardHolder,
                  state.cardNumber,
                  state.cardExpiration,
                  state.cardCCV,
                ),
              installments: state.installments,
              saveCreditCard: false,
            },
          ],
        },
      })
      .then((res) => {
        setError("");
        setLoading(false);
        setOpenLoader(false);
        sessionStorage.setItem(
          "@bookingCompleted",
          JSON.stringify(res),
        );

        switch (res.status) {
          case 200:
            login();
            history.push("/busca/finalizado");
            break;

          case 201:
            if (res.data.auth2fa) {
              if (res.data.redirectAuth2fa !== null) {
                setOpenLoader(true);
                login();
                window.location.replace(res.data.redirectAuth2fa);
              } else {
                setBookingSuccessCode(res);
                setPaymentData(data.paymentData);
                setOpenModal2fa(true);
              }
            } else {
              login();
              history.push("/busca/finalizado");
            }
            break;
          case 202:
            // Demanda 240 - HTTP 202 nao e venda: o grupo do status no fornecedor
            // decide qual mensagem a tela de processamento mostra.
            sessionStorage.setItem("@booking-processing-group", res?.data?.statusGroup || "EM_ANDAMENTO");
            login();
            history.push("/busca/processando");
            break;

          default:
            break;
        }
      })
      .catch((err) => {
        setLoading(false);
        setOpenLoader(false);

        switch (err?.response?.status) {
          case 400: {
            // O backend recusa a reserva com 400 quando: (1) o valor enviado não
            // cobre a tarifa do CheckRate, ou (2) o cartão foi recusado pela operadora.
            // getCheckoutErrorMessage retorna a mensagem específica conforme o tipo de erro.
            setError(getCheckoutErrorMessage(err));
            break;
          }
          case 401:
            history.push("/session-expires");
            break;
          case 409:
            sessionStorage.setItem(
              "@bookingError",
              JSON.stringify(err.response.data.error),
            );
            sessionStorage.setItem(
              "reprocessar",
              JSON.stringify({ reprocessar: false }),
            );
            history.push("/busca/booking-error");
            break;
          case 504:
            sessionStorage.setItem(
              "@bookingError",
              JSON.stringify("Tempo expirou, tente novamente!"),
            );
            sessionStorage.setItem(
              "reprocessar",
              JSON.stringify({ reprocessar: false }),
            );
            history.push("/busca/booking-error");
            break;
          default:
            setError(
              `Ocorreu algum problema, por favor, tente novamente!`,
            );
            break;
        }
      });
  };

  const handleChangeCep = async (cep) => {
    if (cep?.length >= 8) {
      getCep(cep).then(({ data }) => {
        if (data.localidade) {
          setUserDataAddress({
            ...userDataAddress,
            zipCode: cep,
            city: data.localidade,
            state: ufs.find((u) => u.includes(`(${data.uf})`)),
            address: data.logradouro,
          });
        }
      });
    }
  };

  const verifyIfAnyGuestOrPassangerHaveTheSameNameAndLastName = () => {
    if (buscaAtual === "Hotel") {
      // Collect ALL guests across ALL rooms
      const allGuests = quartos.flatMap((quarto) => quarto.hospedes || []);

      // Check duplicate name+lastName across all rooms
      const allNames = allGuests
        .filter((g) => g.name && g.lastName)
        .map((g) => `${g.name} ${g.lastName}`.trim().toUpperCase());

      const hasDuplicateName = allNames.some(
        (name, index) => allNames.indexOf(name) !== index,
      );

      return hasDuplicateName;
    }

    if (buscaAtual !== "Hotel") {
      const convertedPassengers = Object.values(state.passengers);

      const passengersNameAndLastName = convertedPassengers.map(
        (passenger) => `${passenger.name} ${passenger.lastName}`,
      );

      const hasTheSameNameAndLastName = passengersNameAndLastName.filter(
        (passenger, index) =>
          passengersNameAndLastName.includes(passenger, index + 1),
      );

      return hasTheSameNameAndLastName.length > 0;
    }
  };

  const verifyDuplicateDocuments = () => {
    if (buscaAtual === "Hotel") {
      const allGuests = quartos.flatMap((quarto) => quarto.hospedes || []);
      const documentNumbers = allGuests
        .filter(
          (g) => g.documentId && g.documentId.replace(/\D/g, "").length > 0,
        )
        .map((g) => g.documentId.replace(/\D/g, ""));

      return documentNumbers.some(
        (doc, index) => documentNumbers.indexOf(doc) !== index,
      );
    }
    return false;
  };

  const hasInvalidCpfDocument = () => {
    if (!requiresCpfDocument(buscaAtual)) return false;

    if (buscaAtual === "Hotel") {
      return roomDistribution
        .flatMap((room) => room.guests)
        .some(
          (guest) =>
            !validCPF(
              getHospede(guest.roomIndex, guest.index)?.documentId || "",
            ),
        );
    }

    return passengers.some(
      (passenger) =>
        !validCPF(state.passengers[passenger.index]?.documentId || ""),
    );
  };

  const verifyChildAges = () => {
    if (buscaAtual !== "Hotel") return null;

    for (const room of roomDistribution) {
      for (const guest of room.guests) {
        if (guest.label?.substring(0, 7) !== "Criança") continue;

        const ageMatch = guest.label.match(/\((\d+)\)/);
        if (!ageMatch) continue;
        const expectedAge = parseInt(ageMatch[1]);

        const hospede = quartos
          .find((q) => q.quarto === room.roomNumber)
          ?.hospedes?.find((h) => h.hospede === guest.index);

        if (!hospede?.birthdate) continue;
        if (hospede.birthdate.includes("_")) continue;

        // Calculate age directly (DD/MM/YYYY format)
        const parts = hospede.birthdate.split("/");
        if (parts.length !== 3) continue;
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10);
        const year = parseInt(parts[2], 10);
        if (isNaN(day) || isNaN(month) || isNaN(year)) continue;

        const today = new Date();
        let actualAge = today.getFullYear() - year;
        const m = today.getMonth() + 1 - month;
        if (m < 0 || (m === 0 && today.getDate() < day)) actualAge--;

        if (Math.abs(actualAge - expectedAge) > 1) {
          return {
            expected: expectedAge,
            actual: actualAge,
            roomNumber: room.roomNumber + 1,
          };
        }
      }
    }
    return null;
  };

  // Helper: get hospede data from quartos using .find() (not index)
  const getHospede = (roomNumber, guestIndex) => {
    return quartos
      .find((q) => q.quarto === roomNumber)
      ?.hospedes?.find((h) => h.hospede === guestIndex);
  };

  // Check if name+lastName is duplicated across all guests
  const isDuplicateName = (roomNumber, guestIndex) => {
    const hospede = getHospede(roomNumber, guestIndex);
    if (!hospede?.name || !hospede?.lastName) return false;
    const fullName = `${hospede.name} ${hospede.lastName}`.trim().toUpperCase();
    if (!fullName) return false;

    const allGuests = [];
    for (const q of quartos) {
      for (const h of q.hospedes || []) {
        allGuests.push({ ...h, _quarto: q.quarto });
      }
    }

    return allGuests.some(
      (g) =>
        (g._quarto !== roomNumber || g.hospede !== guestIndex) &&
        g.name &&
        g.lastName &&
        `${g.name} ${g.lastName}`.trim().toUpperCase() === fullName,
    );
  };

  // Check if documentId is duplicated across all guests
  const isDuplicateDoc = (roomNumber, guestIndex) => {
    const hospede = getHospede(roomNumber, guestIndex);
    if (!hospede?.documentId) return false;
    const docNum = hospede.documentId.replace(/\D/g, "");
    if (!docNum) return false;

    const allGuests = [];
    for (const q of quartos) {
      for (const h of q.hospedes || []) {
        allGuests.push({ ...h, _quarto: q.quarto });
      }
    }

    return allGuests.some(
      (g) =>
        (g._quarto !== roomNumber || g.hospede !== guestIndex) &&
        g.documentId &&
        g.documentId.replace(/\D/g, "") === docNum,
    );
  };

  // Calculate age from DD/MM/YYYY string
  const calcAgeFromBirthdate = (dateStr) => {
    if (!dateStr || dateStr.includes("_")) return null;
    const parts = dateStr.split("/");
    if (parts.length !== 3) return null;
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10);
    const year = parseInt(parts[2], 10);
    if (isNaN(day) || isNaN(month) || isNaN(year)) return null;
    const today = new Date();
    let age = today.getFullYear() - year;
    const m = today.getMonth() + 1 - month;
    if (m < 0 || (m === 0 && today.getDate() < day)) age--;
    return age;
  };

  // Check if child birthdate doesn't match expected age
  const isChildAgeMismatch = (roomNumber, guestIndex, label) => {
    if (!label || label.substring(0, 7) !== "Criança") return false;
    const ageMatch = label.match(/\((\d+)\)/);
    if (!ageMatch) return false;
    const expectedAge = parseInt(ageMatch[1]);

    const hospede = getHospede(roomNumber, guestIndex);
    const actualAge = calcAgeFromBirthdate(hospede?.birthdate);
    if (actualAge === null) return false;

    return Math.abs(actualAge - expectedAge) > 1;
  };

  // Get message for child age mismatch
  const getChildAgeMismatchMsg = (roomNumber, guestIndex, label) => {
    if (!label) return "";
    const ageMatch = label.match(/\((\d+)\)/);
    if (!ageMatch) return "";
    const expectedAge = parseInt(ageMatch[1]);

    const hospede = getHospede(roomNumber, guestIndex);
    const actualAge = calcAgeFromBirthdate(hospede?.birthdate);
    if (actualAge === null) return "";

    return `Idade esperada: ${expectedAge} ano(s). Data informada corresponde a ${actualAge} ano(s)`;
  };

  const handleKeyPress = (event, maxLength) => {
    const { value } = event.target;
    const charCode = event.which ? event.which : event.keyCode;

    if (value.length >= maxLength) {
      event.preventDefault();
    }
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  };

  useEffect(() => {
    setCoinAlias(user?.campaign?.campaignConfig?.coinAlias || "Pontos");
  }, [user?.campaign?.campaignConfig?.coinAlias]);

  useEffect(() => {
    const inputs = document.querySelectorAll("input");

    inputs.forEach((input) => {
      input.addEventListener("change", (e) => {
        e.target.dispatchEvent(new Event("input", { bubbles: true }));
      });
    });

    return () => {
      inputs.forEach((input) => {
        input.removeEventListener("change", (e) => {
          e.target.dispatchEvent(new Event("input", { bubbles: true }));
        });
      });
    };
  }, []);

  const validateCard = async () => {
    if (
      !state.cardNumber ||
      !state.cardHolder ||
      !state.cardExpiration ||
      !state.cardCCV
    ) {
      return;
    }

    if (!cardFlag.getCardFlag(state.cardNumber)) {
      setCardValidationError(
        "Cartão inválido, confira os dados e tente novamente.",
      );
      return;
    }

    setIsValidatingCard(true);
    setCardValidationError("");

    const cardData = {
      cardNumber: state.cardNumber,
      cardBrand: cardFlag.getCardFlag(state.cardNumber),
      cardType: "Creditcard", // Default
      cardExpirationDate: state.cardExpiration,
      cardSecurityCode: state.cardCCV,
      holder: state.cardHolder,
    };

    try {
      let type = buscaAtual.toLowerCase();
      if (type === "pacote") {
        type = "package-tour";
      }
      if (type === "aéreo") {
        type = "flight";
      }
      if (type === "carro") {
        type = "car";
      }
      // O HUB conhece o service-type "experience" (singular, EN); a busca usa
      // "Experiencias"/"Experiências" (PT, plural). Sem este de->para o HUB
      // retorna 500 "Service type 'experiencias' not implemented".
      if (type === "experiencias" || type === "experiências") {
        type = "experience";
      }
      const response = await bookingsRepository.validateCreditCard(
        type,
        cardData,
      );

      if (response?.status === 200) {
        setCardValidationError("");
      }

      if (!response.data?.data?.valid) {
        setCardValidationError(
          "Cartão inválido, confira os dados e tente novamente.",
        );
      }
    } catch (error) {
      setCardValidationError(
        error.response?.data?.error || "Erro ao validar cartão",
      );
    } finally {
      setIsValidatingCard(false);
    }
  };

  return (
    <S.Wrapper>
      <AppendHead>
        <script type="text/javascript" src={URL}></script>
      </AppendHead>
      <Portal>
        <noscript>
          <iframe
            title="iframeAntiFraud"
            style={{
              width: 100,
              height: 100,
              border: 0,
              position: "absolute",
              top: -5000,
            }}
            src={URL}
          ></iframe>
        </noscript>
      </Portal>

      <Loader
        openLoader={openLoader}
        isGeneral={isGeneralLoading}
        isBooking={!isGeneralLoading}
      />
      <Auth2faModal
        open={openModal2fa}
        onClose={closeModal2fa}
        booking={bookingSuccessCode}
        paymentData={paymentData}
      />
      <CarPoliciesModal
        opened={openCarPoliciesModal}
        policies={carPoliciesData.policies}
        cancellationPolicies={carPoliciesData.cancellationPolicies}
        priceUpdate={carPriceUpdate}
        onAccept={handleCarPoliciesAccept}
        onDecline={handleCarPoliciesDecline}
      />
      <Container>
        <S.Content>
          <Grid container spacing={3}>
            {error && (
              <Grid item xs={12}>
                <Typography variant="span" color="error">
                  {error}
                </Typography>
              </Grid>
            )}

            <Grid item xs={12}>
              <S.Title>Detalhes da Viagem</S.Title>
            </Grid>

            <Grid item xs={12} md={9}>
              {buscaAtual === "Pacote" && (
                <>
                  <PackageSummaryCard buscaAtual={buscaAtual} />
                </>
              )}
              {buscaAtual === "Aéreo" && (
                <>
                  <FlightSummaryCard
                    title="Ida"
                    category={{ detalhes: {}, name: "Light" }}
                    flightCode={`${goingFlight?.validatingcarrier}${goingFlight?.flights[0].flightnumber}`}
                    departureDate={goingFlight?.departuredatetime}
                    arrivalDate={goingFlight?.arrivaldatetime}
                    companyLogo={
                      goingFlight &&
                      getCompanyLogos(goingFlight?.validatingcarrier)
                    }
                    departureAirport={goingFlight?.departurestation}
                    arrivalAirport={goingFlight?.arrivalstation}
                    airplaneFacilities={{
                      wifi: true,
                      share: true,
                      video: true,
                    }}
                    airplaneModel="Airbus A320"
                    company={goingFlight?.validatingcarrier}
                    fareFamily={goingFlight?.flights[0].classofservices[0]}
                    steps={goingFlight?.flights}
                    baggage={goingFlight?.flights[0].fareoption}
                    buscaAtual={buscaAtual}
                  />
                  {dataSelected?.return && (
                    <FlightSummaryCard
                      title="Volta"
                      category={{ detalhes: {}, name: "Light" }}
                      flightCode={`${returnFlight?.validatingcarrier}${returnFlight?.flights[0].flightnumber}`}
                      departureDate={returnFlight?.departuredatetime}
                      arrivalDate={returnFlight?.arrivaldatetime}
                      companyLogo={
                        returnFlight &&
                        getCompanyLogos(returnFlight.validatingcarrier)
                      }
                      departureAirport={returnFlight?.departurestation}
                      arrivalAirport={returnFlight?.arrivalstation}
                      airplaneFacilities={{
                        wifi: true,
                        share: true,
                        video: true,
                      }}
                      airplaneModel="Airbus A320"
                      company={returnFlight?.validatingcarrier}
                      fareFamily={returnFlight?.flights[0].classofservices[0]}
                      steps={returnFlight?.flights}
                      baggage={returnFlight?.flights[0].fareoption}
                      buscaAtual={buscaAtual}
                    />
                  )}
                </>
              )}
              {buscaAtual === "Carro" && (
                <>
                  <CarSummaryCard
                    car={dataSelected}
                    searchState={searchState}
                    buscaAtual={buscaAtual}
                  />
                </>
              )}

              {buscaAtual === "Hotel" && (
                <>
                  {searchState && (
                    <HotelSummaryCard
                      hotel={dataSelected}
                      buscaAtual={buscaAtual}
                    />
                  )}

                  {searchState &&
                    roomDistribution.length > 0 &&
                    roomDistribution.map((room) => (
                      <S.BlankCard key={room.roomNumber}>
                        <div className="title">
                          <S.Title>Quarto {room.roomNumber + 1}</S.Title>
                        </div>
                        <Grid container spacing={1}>
                          {room.guests.map((pass, index) => {
                            return (
                              <React.Fragment
                                key={`${room.roomNumber}-${pass.index}`}
                              >
                                <Grid item xs={12}>
                                  <span>{pass.label}</span>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                  <FormInput
                                    maxLength={28}
                                    onChange={(e) => {
                                      if (
                                        e.target.name === "name" ||
                                        e.target.name === "lastName"
                                      ) {
                                        const normalizedValue = e.target.value
                                          .normalize("NFD")
                                          .replace(/[\u0300-\u036f]/g, "")
                                          .replace(/[^a-zA-Z ]/g, "")
                                          .toUpperCase();

                                        e.target.value = normalizedValue;
                                      }
                                      e.target.value !== "" &&
                                        onChangeRoomGuests({
                                          quarto: room.roomNumber,
                                          hospede: pass.index,
                                          prop: e.target.name,
                                          target: e.target,
                                          value: e.target.value,
                                        });
                                    }}
                                    label="Nome"
                                    name={`name`}
                                    error={
                                      send &&
                                      !getHospede(room.roomNumber, pass.index)
                                        ?.name
                                    }
                                    helperText={
                                      send &&
                                      !getHospede(room.roomNumber, pass.index)
                                        ?.name
                                        ? "Nome não pode ser vazio"
                                        : ""
                                    }
                                  />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                  <FormInput
                                    maxLength={28}
                                    onChange={(e) => {
                                      if (
                                        e.target.name === "name" ||
                                        e.target.name === "lastName"
                                      ) {
                                        const normalizedValue = e.target.value
                                          .normalize("NFD")
                                          .replace(/[\u0300-\u036f]/g, "")
                                          .replace(/[^a-zA-Z ]/g, "")
                                          .toUpperCase();
                                        e.target.value = normalizedValue;
                                      }
                                      e.target.value !== "" &&
                                        onChangeRoomGuests({
                                          quarto: room.roomNumber,
                                          hospede: pass.index,
                                          prop: e.target.name,
                                          target: e.target,
                                          value: e.target.value,
                                        });
                                    }}
                                    label="Sobrenome"
                                    name={`lastName`}
                                    error={
                                      send &&
                                      (!getHospede(room.roomNumber, pass.index)
                                        ?.lastName ||
                                        isDuplicateName(
                                          room.roomNumber,
                                          pass.index,
                                        ))
                                    }
                                    helperText={
                                      send &&
                                      !getHospede(room.roomNumber, pass.index)
                                        ?.lastName
                                        ? "Sobrenome não pode ser vazio"
                                        : send &&
                                          isDuplicateName(
                                            room.roomNumber,
                                            pass.index,
                                          )
                                        ? "Nome e sobrenome já informado em outro hóspede"
                                        : ""
                                    }
                                  />
                                </Grid>
                                {pass.label.substring(0, 7) === "Criança" && (
                                  <>
                                    <Grid item xs={12} sm={6}>
                                      <FormInput
                                        mask="99/99/9999"
                                        onChange={(e) => {
                                          e.target.value !== "" &&
                                            onChangeRoomGuests({
                                              quarto: room.roomNumber,
                                              hospede: pass.index,
                                              prop: e.target.name,
                                              value: e.target.value,
                                            });
                                        }}
                                        label="Data Nascimento"
                                        name="birthdate"
                                        error={
                                          send &&
                                          (!getHospede(
                                            room.roomNumber,
                                            pass.index,
                                          )?.birthdate ||
                                            isChildAgeMismatch(
                                              room.roomNumber,
                                              pass.index,
                                              pass.label,
                                            ))
                                        }
                                        helperText={
                                          send &&
                                          !getHospede(
                                            room.roomNumber,
                                            pass.index,
                                          )?.birthdate
                                            ? "Data Nascimento não pode ser vazio"
                                            : send &&
                                              isChildAgeMismatch(
                                                room.roomNumber,
                                                pass.index,
                                                pass.label,
                                              )
                                            ? getChildAgeMismatchMsg(
                                                room.roomNumber,
                                                pass.index,
                                                pass.label,
                                              )
                                            : ""
                                        }
                                      />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                      <FormInput
                                        onBlur={(e) => {
                                          e.target.value !== "" &&
                                            onChangeRoomGuests({
                                              quarto: room.roomNumber,
                                              hospede: pass.index,
                                              prop: e.target.name,
                                              value: e.target.value,
                                            });
                                        }}
                                        select
                                        name="documentType"
                                        label="Tipo Documento"
                                        value="CPF"
                                        disabled
                                      >
                                        <MenuItem key={0} value="CPF">
                                          CPF
                                        </MenuItem>
                                      </FormInput>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                      <FormInput
                                        onBlur={(e) => {
                                          e.target.value !== "" &&
                                            onChangeRoomGuests({
                                              quarto: room.roomNumber,
                                              hospede: pass.index,
                                              prop: e.target.name,
                                              value: e.target.value,
                                            });
                                        }}
                                        label="Número documento"
                                        name="documentId"
                                        mask="999.999.999-99"
                                        error={
                                          send &&
                                          (!getHospede(
                                            room.roomNumber,
                                            pass.index,
                                          )?.documentId ||
                                            !validCPF(
                                              getHospede(
                                                room.roomNumber,
                                                pass.index,
                                              )?.documentId || "",
                                            ) ||
                                            isDuplicateDoc(
                                              room.roomNumber,
                                              pass.index,
                                            ))
                                        }
                                        helperText={
                                          send &&
                                          !getHospede(
                                            room.roomNumber,
                                            pass.index,
                                          )?.documentId
                                            ? "CPF não pode ser vazio"
                                            : send &&
                                              !validCPF(
                                                getHospede(
                                                  room.roomNumber,
                                                  pass.index,
                                                )?.documentId || "",
                                              )
                                            ? "CPF inválido"
                                            : send &&
                                              isDuplicateDoc(
                                                room.roomNumber,
                                                pass.index,
                                              )
                                            ? "Documento já informado em outro hóspede"
                                            : ""
                                        }
                                      />
                                    </Grid>
                                  </>
                                )}
                                {pass.label.substring(0, 7) !== "Criança" && (
                                  <>
                                    <Grid item xs={12} sm={6}>
                                      <FormInput
                                        mask="99/99/9999"
                                        onChange={(e) => {
                                          e.target.value !== "" &&
                                            onChangeRoomGuests({
                                              quarto: room.roomNumber,
                                              hospede: pass.index,
                                              prop: e.target.name,
                                              value: e.target.value,
                                            });
                                        }}
                                        label="Data Nascimento"
                                        name="birthdate"
                                      />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                      <FormInput
                                        onBlur={(e) => {
                                          e.target.value !== "" &&
                                            onChangeRoomGuests({
                                              quarto: room.roomNumber,
                                              hospede: pass.index,
                                              prop: e.target.name,
                                              value: e.target.value,
                                            });
                                        }}
                                        select
                                        name="documentType"
                                        label="Tipo Documento"
                                        value="CPF"
                                        disabled
                                      >
                                        <MenuItem key={0} value="CPF">
                                          CPF
                                        </MenuItem>
                                      </FormInput>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                      <FormInput
                                        onBlur={(e) => {
                                          e.target.value !== "" &&
                                            onChangeRoomGuests({
                                              quarto: room.roomNumber,
                                              hospede: pass.index,
                                              prop: e.target.name,
                                              value: e.target.value,
                                            });
                                        }}
                                        label="Número documento"
                                        name="documentId"
                                        mask="999.999.999-99"
                                        error={
                                          send &&
                                          (!getHospede(
                                            room.roomNumber,
                                            pass.index,
                                          )?.documentId ||
                                            !validCPF(
                                              getHospede(
                                                room.roomNumber,
                                                pass.index,
                                              )?.documentId || "",
                                            ) ||
                                            isDuplicateDoc(
                                              room.roomNumber,
                                              pass.index,
                                            ))
                                        }
                                        helperText={
                                          send &&
                                          !getHospede(
                                            room.roomNumber,
                                            pass.index,
                                          )?.documentId
                                            ? "CPF não pode ser vazio"
                                            : send &&
                                              !validCPF(
                                                getHospede(
                                                  room.roomNumber,
                                                  pass.index,
                                                )?.documentId || "",
                                              )
                                            ? "CPF inválido"
                                            : send &&
                                              isDuplicateDoc(
                                                room.roomNumber,
                                                pass.index,
                                              )
                                            ? "Documento já informado em outro hóspede"
                                            : ""
                                        }
                                      />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                      <FormInput
                                        onBlur={(e) => {
                                          e.target.value !== "" &&
                                            onChangeRoomGuests({
                                              quarto: room.roomNumber,
                                              hospede: pass.index,
                                              prop: e.target.name,
                                              value: e.target.value,
                                            });
                                        }}
                                        label="E-mail"
                                        name="email"
                                        error={
                                          send &&
                                          !validEmail(
                                            getHospede(
                                              room.roomNumber,
                                              pass.index,
                                            )?.email,
                                          )
                                        }
                                        helperText={
                                          send &&
                                          !validEmail(
                                            getHospede(
                                              room.roomNumber,
                                              pass.index,
                                            )?.email,
                                          )
                                            ? "E-mail precisa ser preenchido com um e-mail valido"
                                            : ""
                                        }
                                      />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                      <FormInput
                                        mask="(99) 99999-9999"
                                        onBlur={(e) => {
                                          e.target.value !== "" &&
                                            onChangeRoomGuests({
                                              quarto: room.roomNumber,
                                              hospede: pass.index,
                                              prop: e.target.name,
                                              value: e.target.value,
                                            });
                                        }}
                                        label="Telefone"
                                        name="phone"
                                        error={
                                          send &&
                                          !getHospede(
                                            room.roomNumber,
                                            pass.index,
                                          )?.phone
                                        }
                                        helperText={
                                          send &&
                                          !getHospede(
                                            room.roomNumber,
                                            pass.index,
                                          )?.phone
                                            ? "Telefone não pode ser vazio"
                                            : ""
                                        }
                                      />
                                    </Grid>
                                  </>
                                )}
                              </React.Fragment>
                            );
                          })}
                        </Grid>
                      </S.BlankCard>
                    ))}
                </>
              )}
              {buscaAtual === "Rodoviário" && (
                <>
                  <BusSummaryCard
                    searchState={searchState}
                    goingRoute={goingRoute}
                    returnRoute={returnRoute}
                    openServiceTermsAndPrivacyPolicyBusModal={
                      setOpenServiceTermsAndPrivacyPolicyBusModal
                    }
                    selectedGoingSeats={selectedGoingSeats}
                    setSelectedGoingSeats={setSelectedGoingSeats}
                    selectedReturnSeats={selectedReturnSeats}
                    setSelectedReturnSeats={setSelectedReturnSeats}
                    result={result}
                    seatMapIda={seatMapIda}
                    seatMapVolta={seatMapVolta}
                    loading={loadingSeats}
                  ></BusSummaryCard>
                </>
              )}
              {buscaAtual !== "Hotel" &&
                passengers.map((pass) => (
                  <S.BlankCard>
                    <div className="title">
                      <S.Title>
                        {buscaAtual === "Carro"
                          ? `Dados do motorista`
                          : `Dados do Passageiro ${pass.index + 1} (${
                              pass.tipo
                            })`}
                      </S.Title>
                    </div>
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={6}>
                        <FormInput
                          onBlur={(e) =>
                            onChangePassengers(pass.tipo, pass.index, e)
                          }
                          maxLength={28}
                          label="Nome"
                          name="name"
                          error={send && !state.passengers[pass.index].name}
                          helperText={
                            send && !state.passengers[pass.index].name
                              ? "Nome não pode ser vazio"
                              : ""
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormInput
                          maxLength={28}
                          onBlur={(e) =>
                            onChangePassengers(pass.tipo, pass.index, e)
                          }
                          label="Sobrenome"
                          name="lastName"
                          error={send && !state.passengers[pass.index].lastName}
                          helperText={
                            send && !state.passengers[pass.index].lastName
                              ? "Sobrenome não pode ser vazio"
                              : ""
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormInput
                          mask="99/99/9999"
                          onChange={(e) =>
                            onChangePassengers(pass.tipo, pass.index, e)
                          }
                          label="Data Nascimento"
                          name="birthdate"
                          error={
                            send && !state.passengers[pass.index].birthdate
                          }
                          helperText={
                            send && !state.passengers[pass.index].birthdate
                              ? "Data de nascimento não pode ser vazio"
                              : ""
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormInput
                          onBlur={(e) =>
                            onChangePassengers(pass.tipo, pass.index, e)
                          }
                          select
                          label="Sexo"
                          name="gender"
                          value={state.passengers[pass.index].gender}
                          error={send && !state.passengers[pass.index].gender}
                          helperText={
                            send && !state.passengers[pass.index].gender
                              ? "Genero não pode ser vazio"
                              : ""
                          }
                        >
                          <MenuItem key={0} value="M">
                            Masculino
                          </MenuItem>
                          <MenuItem key={1} value="F">
                            Feminino
                          </MenuItem>
                          <MenuItem key={2} value="O">
                            Outro
                          </MenuItem>
                        </FormInput>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormInput
                          onBlur={(e) =>
                            onChangePassengers(pass.tipo, pass.index, e)
                          }
                          select
                          name="documentType"
                          label="Tipo Documento"
                          value={
                            requiresCpfDocument(buscaAtual)
                              ? "CPF"
                              : state.passengers[pass.index].documentType
                          }
                          disabled={requiresCpfDocument(buscaAtual)}
                          error={
                            !requiresCpfDocument(buscaAtual) &&
                            send &&
                            !state.passengers[pass.index].documentType
                          }
                          helperText={
                            !requiresCpfDocument(buscaAtual) &&
                            send &&
                            !state.passengers[pass.index].documentType
                              ? "Tipo de documento não pode ser vazio"
                              : ""
                          }
                        >
                          <MenuItem key={0} value="CPF">
                            CPF
                          </MenuItem>
                          <MenuItem key={1} value="CNH">
                            CNH
                          </MenuItem>
                          <MenuItem key={2} value="RG">
                            RG
                          </MenuItem>
                        </FormInput>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormInput
                          {...(!requiresCpfDocument(buscaAtual) && {
                            onKeyPress: (e) => handleKeyPress(e, 11),
                            inputProps: { maxLength: 11 },
                          })}
                          onBlur={(e) =>
                            onChangePassengers(pass.tipo, pass.index, e)
                          }
                          label={"Número documento"}
                          name="documentId"
                          mask={
                            requiresCpfDocument(buscaAtual)
                              ? "999.999.999-99"
                              : ""
                          }
                          error={
                            (send &&
                              !state.passengers[pass.index].documentId) ||
                            (requiresCpfDocument(buscaAtual) &&
                              !!state.passengers[pass.index].documentId &&
                              !validCPF(
                                state.passengers[pass.index].documentId,
                              ))
                          }
                          helperText={
                            send && !state.passengers[pass.index].documentId
                              ? "CPF não pode ser vazio"
                              : requiresCpfDocument(buscaAtual) &&
                                !!state.passengers[pass.index].documentId &&
                                !validCPF(
                                  state.passengers[pass.index].documentId,
                                )
                              ? "CPF inválido"
                              : ""
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormInput
                          onBlur={(e) =>
                            onChangePassengers(pass.tipo, pass.index, e)
                          }
                          label="E-mail"
                          name="email"
                          error={
                            send &&
                            !validEmail(state?.passengers[pass.index]?.email)
                          }
                          helperText={
                            send &&
                            !validEmail(state?.passengers[pass.index]?.email)
                              ? "E-mail precisa ser preenchido com um e-mail valido"
                              : ""
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormInput
                          mask="(99) 99999-9999"
                          onBlur={(e) =>
                            onChangePassengers(pass.tipo, pass.index, e)
                          }
                          label="Telefone"
                          name="phone"
                          error={send && !state.passengers[pass.index].phone}
                          helperText={
                            send && !state.passengers[pass.index].phone
                              ? "Telefone não pode ser vazio"
                              : ""
                          }
                        />
                      </Grid>
                      {(buscaAtual === "Experiencias" ||
                        buscaAtual === "Carro") && (
                        <Grid item xs={12} sm={12}>
                          <FormInput
                            onBlur={(e) =>
                              onChangePassengers(pass.tipo, pass.index, e)
                            }
                            label="Endereço completo"
                            name="address"
                            error={
                              send && !state.passengers[pass.index].address
                            }
                            helperText={
                              send && !state.passengers[pass.index].address
                                ? "Endereço não pode ser vazio"
                                : ""
                            }
                          />
                        </Grid>
                      )}
                    </Grid>
                  </S.BlankCard>
                ))}
              {buscaAtual === "Entretenimento" &&
                activityCategory === "transfer" && (
                  <S.BlankCard>
                    <div className="title">
                      <S.Title>Dados do transfer:</S.Title>
                    </div>
                    <span>
                      Para que sua experiência seja realizada, é necessário
                      completar os dados solicitados a seguir.
                    </span>
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <div className="radio-group">
                          <span>
                            Você vai iniciar o serviço em um Aeroporto? *
                          </span>
                          <div className="radio-options">
                            <label>
                              <input
                                type="radio"
                                name="iniciaAeroporto"
                                value="sim"
                                checked={isStartingAirport}
                                onChange={() => setIsStartingAirport(true)}
                              />
                              Sim
                            </label>
                            <label>
                              <input
                                type="radio"
                                name="iniciaAeroporto"
                                value="nao"
                                checked={!isStartingAirport}
                                onChange={() => setIsStartingAirport(false)}
                              />
                              Não
                            </label>
                          </div>
                          {isStartingAirport ? (
                            <div className="airport-details">
                              <FormInput
                                label="Nome ou sigla do Aeroporto de início"
                                style={{ minWidth: "300px" }}
                                onChange={(e) =>
                                  setTransferData((prev) => ({
                                    ...prev,
                                    startingAirport: {
                                      ...prev.startingAirport,
                                      name: e.target.value,
                                    },
                                  }))
                                }
                                error={
                                  send &&
                                  !transferData.startingAirport.name &&
                                  isDestinationAirport === true
                                }
                                helperText={
                                  send &&
                                  !transferData.startingAirport.name &&
                                  isDestinationAirport === true
                                    ? "Nome ou sigla do Aeroporto de início não pode ser vazio"
                                    : ""
                                }
                              />
                              <FormInput
                                label="Código da reserva"
                                onChange={(e) =>
                                  setTransferData((prev) => ({
                                    ...prev,
                                    startingAirport: {
                                      ...prev.startingAirport,
                                      reservationCode: e.target.value,
                                    },
                                  }))
                                }
                                error={
                                  send &&
                                  !transferData.startingAirport
                                    .reservationCode &&
                                  isDestinationAirport === true
                                }
                                helperText={
                                  send &&
                                  !transferData.startingAirport
                                    .reservationCode &&
                                  isDestinationAirport === true
                                    ? "Código da reserva não pode ser vazio"
                                    : ""
                                }
                              />
                              <FormInput
                                label="Núm. do vôo de início"
                                onChange={(e) =>
                                  setTransferData((prev) => ({
                                    ...prev,
                                    startingAirport: {
                                      ...prev.startingAirport,
                                      flightNumber: e.target.value,
                                    },
                                  }))
                                }
                                error={
                                  send &&
                                  !transferData.startingAirport.flightNumber &&
                                  isDestinationAirport === true
                                }
                                helperText={
                                  send &&
                                  !transferData.startingAirport.flightNumber &&
                                  isDestinationAirport === true
                                    ? "Número do vôo de início não pode ser vazio"
                                    : ""
                                }
                              />
                              <FormInput
                                label="Hora de chegada do vôo"
                                onChange={(e) =>
                                  setTransferData((prev) => ({
                                    ...prev,
                                    startingAirport: {
                                      ...prev.startingAirport,
                                      arrivalTime: e.target.value,
                                    },
                                  }))
                                }
                                error={
                                  send &&
                                  !transferData.startingAirport.arrivalTime &&
                                  isDestinationAirport === true
                                }
                                helperText={
                                  send &&
                                  !transferData.startingAirport.arrivalTime &&
                                  isDestinationAirport === true
                                    ? "Hora de chegada do vôo de início não pode ser vazio"
                                    : ""
                                }
                              />
                            </div>
                          ) : (
                            <div className="airport-details">
                              <FormInput
                                label="Nome e endereço do local onde o Transfer irá te encontrar"
                                style={{ minWidth: "100%" }}
                                onChange={(e) =>
                                  setTransferData((prev) => ({
                                    ...prev,
                                    pickupLocation: e.target.value,
                                  }))
                                }
                                error={
                                  send &&
                                  !transferData.pickupLocation &&
                                  isDestinationAirport === false
                                }
                                helperText={
                                  send &&
                                  !transferData.pickupLocation &&
                                  isDestinationAirport === false
                                    ? "Nome e endereço do local onde o Transfer irá te encontrar não pode ser vazio"
                                    : ""
                                }
                              />
                            </div>
                          )}
                        </div>
                      </Grid>

                      <Grid item xs={12}>
                        <div className="radio-group">
                          <span>O seu destino será um Aeroporto? *</span>
                          <div className="radio-options">
                            <label>
                              <input
                                type="radio"
                                name="destinoAeroporto"
                                value="sim"
                                checked={isDestinationAirport}
                                onChange={() => setIsDestinationAirport(true)}
                              />
                              Sim
                            </label>
                            <label>
                              <input
                                type="radio"
                                name="destinoAeroporto"
                                value="nao"
                                checked={!isDestinationAirport}
                                onChange={() => setIsDestinationAirport(false)}
                              />
                              Não
                            </label>
                          </div>
                          {isDestinationAirport ? (
                            <div className="airport-details">
                              <FormInput
                                label="Nome ou sigla do Aeroporto de destino"
                                style={{ minWidth: "300px" }}
                                onChange={(e) =>
                                  setTransferData((prev) => ({
                                    ...prev,
                                    destinationAirport: {
                                      ...prev.destinationAirport,
                                      name: e.target.value,
                                    },
                                  }))
                                }
                                error={
                                  send &&
                                  !transferData.destinationAirport.name &&
                                  isDestinationAirport === true
                                }
                                helperText={
                                  send &&
                                  !transferData.destinationAirport.name &&
                                  isDestinationAirport === true
                                    ? "Nome ou sigla do Aeroporto de destino não pode ser vazio"
                                    : ""
                                }
                              />
                              <FormInput
                                label="Código da reserva"
                                onChange={(e) =>
                                  setTransferData((prev) => ({
                                    ...prev,
                                    destinationAirport: {
                                      ...prev.destinationAirport,
                                      reservationCode: e.target.value,
                                    },
                                  }))
                                }
                                error={
                                  send &&
                                  !transferData.destinationAirport
                                    .reservationCode &&
                                  isDestinationAirport === true
                                }
                                helperText={
                                  send &&
                                  !transferData.destinationAirport
                                    .reservationCode &&
                                  isDestinationAirport === true
                                    ? "Código da reserva não pode ser vazio"
                                    : ""
                                }
                              />
                              <FormInput
                                label="Núm. do vôo de destino"
                                onChange={(e) =>
                                  setTransferData((prev) => ({
                                    ...prev,
                                    destinationAirport: {
                                      ...prev.destinationAirport,
                                      flightNumber: e.target.value,
                                    },
                                  }))
                                }
                                error={
                                  send &&
                                  !transferData.destinationAirport
                                    .flightNumber &&
                                  isDestinationAirport === true
                                }
                                helperText={
                                  send &&
                                  !transferData.destinationAirport
                                    .flightNumber &&
                                  isDestinationAirport === true
                                    ? "Número do vôo de destino não pode ser vazio"
                                    : ""
                                }
                              />
                              <FormInput
                                label="Hora de chegada do vôo"
                                onChange={(e) =>
                                  setTransferData((prev) => ({
                                    ...prev,
                                    destinationAirport: {
                                      ...prev.destinationAirport,
                                      arrivalTime: e.target.value,
                                    },
                                  }))
                                }
                                error={
                                  send &&
                                  !transferData.destinationAirport
                                    .arrivalTime &&
                                  isDestinationAirport === true
                                }
                                helperText={
                                  send &&
                                  !transferData.destinationAirport
                                    .arrivalTime &&
                                  isDestinationAirport === true
                                    ? "Hora de chegada do vôo de destino não pode ser vazio"
                                    : ""
                                }
                              />
                            </div>
                          ) : (
                            <div className="airport-details">
                              <FormInput
                                label="Nome e endereço do local onde o Transfer irá te levar"
                                style={{ minWidth: "100%" }}
                                onChange={(e) =>
                                  setTransferData((prev) => ({
                                    ...prev,
                                    dropOffLocation: e.target.value,
                                  }))
                                }
                                error={
                                  send &&
                                  !transferData.dropOffLocation &&
                                  isDestinationAirport === false
                                }
                                helperText={
                                  send &&
                                  !transferData.dropOffLocation &&
                                  isDestinationAirport === false
                                    ? "Nome e endereço do local onde o Transfer irá te levar não pode ser vazio"
                                    : ""
                                }
                              />
                            </div>
                          )}
                        </div>
                      </Grid>
                    </Grid>
                  </S.BlankCard>
                )}
              {user?.campaign?.acceptCashPayment && (
                <>
                  {!user?.guest && !user?.campaign?.disablePointActivity && (
                    <S.BlankCard>
                      <div className="title">
                        <S.Title>Pagamento em</S.Title>
                      </div>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                          <FormInput
                            disabled={discountPoints ? true : false}
                            type="number"
                            label={`Valor do Saldo`}
                            value={paymentInPoints}
                            step="1"
                            error={
                              paymentInPoints < minimumPointsToBuy ||
                              paymentInPoints > userPoints
                            }
                            helperText={
                              paymentInPoints > userPoints
                                ? `Valor em ${coinAlias} maior que seu saldo de ${coinAlias}`
                                : paymentInPoints < minimumPointsToBuy &&
                                  `Quantidade de ${coinAlias} não pode ser menor que ${minimumPointsToBuy}`
                            }
                            onChange={(e) => {
                              let inputValue = e.target.value;

                              // Round to integer (no decimals allowed for points)
                              if (inputValue !== "") {
                                // Check if value contains decimal point or is decimal
                                if (
                                  inputValue.includes(".") ||
                                  inputValue.includes(",")
                                ) {
                                  inputValue = Math.round(
                                    parseFloat(inputValue),
                                  );
                                }
                              }

                              if (
                                inputValue <= pointsPrice ||
                                inputValue === ""
                              ) {
                                setPaymentInPoints(inputValue);
                                if (inputValue >= pointsPrice) {
                                  setPaymentInMoney(0);
                                } else {
                                  castPointsToMoney(inputValue);
                                }
                              }
                            }}
                          />
                          {/* {discountPoints ? (
                        <Typography variant='span' style={{ color: 'green' }}>
                          Desconto aplicado de:{' '}
                          <strong>{discountPoints} pontos</strong>
                        </Typography>
                      ) : (
                        <></>
                      )} */}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <FormInput
                            type="number"
                            label="Valor adicional em R$"
                            value={paymentInMoney}
                            disabled={discountPoints ? true : false}
                            onChange={(e) => {
                              if (parseFloat(e.target.value).toFixed(2) >= 0) {
                                if (
                                  parseFloat(e.target.value).toFixed(2) <=
                                  cashPrice
                                ) {
                                  setPaymentInMoney(
                                    parseFloat(e.target.value).toFixed(2),
                                  );
                                  castMoneyToPoints(
                                    parseFloat(e.target.value).toFixed(2),
                                  );
                                }
                              }
                            }}
                          />
                        </Grid>
                      </Grid>
                    </S.BlankCard>
                  )}
                </>
              )}
              {user?.campaign?.couponEnabled && (
                <S.BlankCard>
                  <div className="title">
                    <S.Title>Cupom de desconto</S.Title>
                  </div>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                      <FormInput
                        onChange={(e) => {
                          setCouponError("");
                          setDiscountCoupon(e.target.value);
                        }}
                        label="Digite um cupom de desconto"
                        name="discountCoupon"
                        value={discountCoupon}
                        disabled={discountPoints || discountCash}
                      />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <ThemeButton
                        onClick={() => {
                          setIsGeneralLoading(true);
                          setLoading(true);
                          setOpenLoader(true);
                          validateCoupon(discountCoupon);
                        }}
                        className={`payment coupon`}
                        disabled={
                          discountCoupon
                            ? discountPoints || discountCash
                              ? true
                              : false
                            : true
                        }
                      >
                        Aplicar cupom
                      </ThemeButton>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <ThemeButton
                        onClick={() => removeCoupon()}
                        className={`payment coupon`}
                        disabled={discountPoints || discountCash ? false : true}
                      >
                        Remover cupom
                      </ThemeButton>
                    </Grid>
                    {couponError && (
                      <Grid item xs={12}>
                        <Typography variant="span" color="error">
                          {couponError}
                        </Typography>
                      </Grid>
                    )}
                    {!couponError &&
                      (discountPoints > 0 || discountCash > 0) && (
                        <Grid item xs={12}>
                          <Typography variant="span" style={{ color: "green" }}>
                            Cupom aplicado com sucesso!
                          </Typography>
                        </Grid>
                      )}
                  </Grid>
                </S.BlankCard>
              )}
              {user?.campaign?.acceptCashPayment && paymentInMoney > 0 && (
                <>
                  <S.BlankCard>
                    <div className="title">
                      <S.Title>Forma de Pagamento</S.Title>
                    </div>
                    <Grid container spacing={3}>
                      <Grid item xs={6}>
                        <CardFlags />
                      </Grid>
                      {userCardDataSaved.length > 0 && (
                        <Grid item xs={6}>
                          {savedCard(
                            userCardDataSaved[0].brand,
                            userCardDataSaved[0].last4Digits,
                          )}
                        </Grid>
                      )}
                    </Grid>

                    {!useSavedCard && (
                      <Grid
                        container
                        spacing={3}
                        style={{ position: "relative" }}
                      >
                        {isValidatingCard && (
                          <div
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              backgroundColor: "rgba(255, 255, 255, 0.7)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              zIndex: 1,
                            }}
                          >
                            <CircularProgress />
                          </div>
                        )}
                        <Grid item xs={12} sm={6}>
                          <FormInput
                            onChange={onChangeField}
                            label="Nome do Titular do Cartão"
                            name="cardHolder"
                            error={!useSavedCard && send && !state.cardHolder}
                            helperText={
                              !useSavedCard && send && !state.cardHolder
                                ? "Nome do titular do cartão não pode ser vazio"
                                : ""
                            }
                            onBlur={() => {
                              if (
                                state.cardNumber &&
                                state.cardExpiration &&
                                state.cardCCV
                              ) {
                                validateCard();
                              }
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <FormInput
                            onChange={onChangeField}
                            label="Número do Cartão"
                            name="cardNumber"
                            error={!useSavedCard && send && !state.cardNumber}
                            helperText={
                              !useSavedCard && send && !state.cardNumber
                                ? "Número do cartão não pode ser vazio"
                                : ""
                            }
                            onBlur={() => {
                              if (
                                state.cardHolder &&
                                state.cardExpiration &&
                                state.cardCCV
                              ) {
                                validateCard();
                              }
                            }}
                          />
                          {state.cardNumber && (
                            <label className="cardFlag">
                              {cardFlag.getCardFlag(state?.cardNumber)}
                            </label>
                          )}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <FormInput
                            mask="99/9999"
                            onChange={onChangeField}
                            label="Data de expiração"
                            name="cardExpiration"
                            error={
                              !useSavedCard && send && !state.cardExpiration
                            }
                            helperText={
                              !useSavedCard && send && !state.cardExpiration
                                ? "Data de expiração do cartão não pode ser vazio"
                                : ""
                            }
                            onBlur={() => {
                              if (
                                state.cardHolder &&
                                state.cardNumber &&
                                state.cardCCV
                              ) {
                                validateCard();
                              }
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <FormInput
                            onChange={onChangeField}
                            label="Código CVV"
                            name="cardCCV"
                            error={!useSavedCard && send && !state.cardCCV}
                            helperText={
                              !useSavedCard && send && !state.cardCCV
                                ? "CCV do cartão não pode ser vazio"
                                : ""
                            }
                            onBlur={() => {
                              if (
                                state.cardHolder &&
                                state.cardNumber &&
                                state.cardExpiration
                              ) {
                                validateCard();
                              }
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <FormInput
                            onChange={onChangeField}
                            label="Número de parcelas"
                            name="installments"
                            select
                            error={!useSavedCard && send && !state.installments}
                            helperText={
                              !useSavedCard && send && !state.installments
                                ? "Número de parcelas não pode ser vazio"
                                : ""
                            }
                          >
                            {installmentsNumber.map((installment) => (
                              <MenuItem key={installment} value={installment}>
                                {installment}
                              </MenuItem>
                            ))}
                          </FormInput>
                        </Grid>
                        {cardValidationError && (
                          <Grid item xs={12}>
                            <S.AlertStyle>
                              <Alert variant="filled" severity="error">
                                {cardValidationError}
                              </Alert>
                            </S.AlertStyle>
                          </Grid>
                        )}
                      </Grid>
                    )}
                  </S.BlankCard>
                  <S.BlankCard>
                    <div className="title">
                      <S.Title>Dados de cobrança</S.Title>
                    </div>
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={6}>
                        <FormInput
                          onChange={onChangeFieldCobranca}
                          label="CPF"
                          name="documentNumber"
                          error={send && !userDataAddress.documentNumber}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormInput
                          onChange={onChangeFieldCobranca}
                          label="E-mail"
                          name="email"
                          error={send && !userDataAddress.email}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormInput
                          mask="(99) 99999-9999"
                          onChange={onChangeFieldCobranca}
                          label="Celular"
                          name="mobilePhoneNumber"
                          error={send && !userDataAddress.mobilePhoneNumber}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormInput
                          onChange={onChangeFieldCobranca}
                          onBlur={(e) => handleChangeCep(e.target.value)}
                          label="CEP"
                          name="zipCode"
                          error={send && !userDataAddress.zipCode}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormInput
                          onChange={onChangeFieldCobranca}
                          label="Endereço"
                          name="address"
                          value={userDataAddress.address}
                          error={send && !userDataAddress.address}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormInput
                          onChange={onChangeFieldCobranca}
                          label="Número endereço"
                          name="number"
                          error={send && !userDataAddress.number}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormInput
                          onChange={onChangeFieldCobranca}
                          select
                          label="Estado"
                          name="state"
                          value={userDataAddress.state}
                          error={send && !userDataAddress.state}
                        >
                          {ufs.map((uf, index) => (
                            <MenuItem value={uf} key={index}>
                              {uf}
                            </MenuItem>
                          ))}
                        </FormInput>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormInput
                          onChange={onChangeFieldCobranca}
                          label="Cidade"
                          name="city"
                          value={userDataAddress.city}
                          error={send && !userDataAddress.city}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormInput
                          onChange={onChangeFieldCobranca}
                          label="Complemento"
                          name="complement"
                          //error={send && !userDataAddress.complement}
                        />
                      </Grid>
                    </Grid>
                  </S.BlankCard>
                </>
              )}
              <S.AlertStyle>
                <Alert variant="filled" severity="info">
                  <span className="text">
                    Clicando em 'Comprar', você está concordando com nossos{" "}
                    <Link
                      component="button"
                      variant="body2"
                      color="inherit"
                      onClick={() => {
                        setOpenServiceTermsAndPrivacyPolicyModal(true);
                      }}
                    >
                      termos de uso e política de confidencialidade
                    </Link>{" "}
                    e com a possibilidade de entrarmos em contato pelos meios
                    disponíveis, inclusive via WhatsApp.
                  </span>
                </Alert>
              </S.AlertStyle>
              {openServiceTermsAndPrivacyPolicyModal && (
                <SimpleModal
                  opened={openServiceTermsAndPrivacyPolicyModal}
                  openedState={setOpenServiceTermsAndPrivacyPolicyModal}
                  title={useTerms?.description}
                  text={useTerms?.content}
                  closeButtonText="Declaro ter lido os termos"
                  allowCloseByClickOutside={false}
                  closeButtonDisabledTillScrollEnded={true}
                />
              )}
              {openServiceTermsAndPrivacyPolicyBusModal && (
                <SimpleBusModal
                  opened={openServiceTermsAndPrivacyPolicyBusModal}
                  openedState={setOpenServiceTermsAndPrivacyPolicyBusModal}
                  policies={policies}
                  closeButtonText="Declaro ter lido as políticas da companhia"
                  allowCloseByClickOutside={false}
                  closeButtonDisabledTillScrollEnded={true}
                />
              )}
              {/* Hotel Cancellation Policy Modal */}
              {openHotelCancellationPolicyModal && buscaAtual === "Hotel" && (
                <SimpleModal
                  opened={openHotelCancellationPolicyModal}
                  openedState={setOpenHotelCancellationPolicyModal}
                  title="Política de Cancelamento e Regras Tarifárias"
                  text={(() => {
                    const roomsData = getSessionStorage("@roomSelected");
                    const rooms = Array.isArray(roomsData)
                      ? roomsData
                      : [roomsData];
                    let policiesHtml = "";

                    rooms.forEach((room, index) => {
                      const cancellation =
                        room?.rateSelected?.cancellationPolicies ||
                        room?.room?.roomRates?.[0]?.cancellationPolicies;
                      const roomName = room?.roomName || `Quarto ${index + 1}`;
                      const mealPlan =
                        room?.rateSelected?.mealPlan ||
                        room?.room?.roomRates?.[0]?.mealPlan ||
                        "";

                      policiesHtml += `<div style="margin-bottom: 20px;">`;
                      policiesHtml += `<h3 style="margin-bottom: 10px;">${roomName}</h3>`;

                      if (mealPlan) {
                        policiesHtml += `<p><strong>Regime de alimentação:</strong> ${mealPlan}</p>`;
                      }

                      if (cancellation) {
                        policiesHtml += `<p><strong>Reembolsável:</strong> ${
                          cancellation.refundable ? "Sim" : "Não"
                        }</p>`;

                        if (
                          cancellation.penalties &&
                          cancellation.penalties.length > 0
                        ) {
                          policiesHtml += `<div style="margin-top: 10px;"><strong>Multas de cancelamento:</strong><ul>`;
                          cancellation.penalties.forEach((penalty) => {
                            const penaltyDate = penalty.from
                              ? new Date(penalty.from).toLocaleDateString(
                                  "pt-BR",
                                )
                              : "";
                            const penaltyAmount = penalty.price?.amount
                              ? new Intl.NumberFormat("pt-BR", {
                                  style: "currency",
                                  currency: "BRL",
                                }).format(penalty.price.amount)
                              : "";
                            policiesHtml += `<li style="margin: 8px 0;">`;
                            if (penalty.name)
                              policiesHtml += `<strong>${penalty.name}</strong><br/>`;
                            if (penalty.description)
                              policiesHtml += `${penalty.description}<br/>`;
                            if (penaltyDate)
                              policiesHtml += `A partir de: ${penaltyDate}<br/>`;
                            if (penaltyAmount)
                              policiesHtml += `Valor da multa: ${penaltyAmount}`;
                            policiesHtml += `</li>`;
                          });
                          policiesHtml += `</ul></div>`;
                        }
                      } else {
                        policiesHtml += `<p>Política de cancelamento não disponível.</p>`;
                      }

                      policiesHtml += `</div><hr style="margin: 15px 0; border: none; border-top: 1px solid #eee;"/>`;
                    });

                    return policiesHtml;
                  })()}
                  closeButtonText="Fechar"
                  allowCloseByClickOutside={true}
                  closeButtonDisabledTillScrollEnded={false}
                />
              )}
              {/* Hotel Cancellation Policy Checkbox */}
              {buscaAtual === "Hotel" && (
                <S.HotelPolicyCheckbox>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={hotelCancellationPolicyAccepted}
                        onChange={(e) =>
                          setHotelCancellationPolicyAccepted(e.target.checked)
                        }
                        color="primary"
                      />
                    }
                    label={
                      <span>
                        Li e aceito a{" "}
                        <Link
                          component="button"
                          variant="body2"
                          onClick={(e) => {
                            e.preventDefault();
                            setOpenHotelCancellationPolicyModal(true);
                          }}
                          style={{
                            fontWeight: "bold",
                            textDecoration: "underline",
                          }}
                        >
                          política de cancelamento e regras tarifárias
                        </Link>
                      </span>
                    }
                  />
                </S.HotelPolicyCheckbox>
              )}
              {/* Flight Cancellation Policy Modal */}
              {openFlightCancellationPolicyModal && buscaAtual === "Aéreo" && (
                <SimpleModal
                  opened={openFlightCancellationPolicyModal}
                  openedState={setOpenFlightCancellationPolicyModal}
                  title="Política de Cancelamento e Regras Tarifárias do Voo"
                  text={(() => {
                    if (loadingFareRules) {
                      return "<p style='font-size: 13px; color: #666;'>Carregando regras tarifárias...</p>";
                    }

                    if (isTranslating) {
                      return "<p style='font-size: 13px; color: #666;'>Traduzindo regras tarifárias, aguarde...</p>";
                    }

                    const pricingData = flightFareRulesData;
                    const rulesData =
                      translatedRulesInfo || pricingData?.rulesinfo;
                    let rulesHtml = "";

                    if (rulesData && rulesData.length > 0) {
                      // Botão traduzir / ver original
                      if (translatedRulesInfo) {
                        rulesHtml += `<div style="margin-bottom: 12px; text-align: right;"><button onclick="window.__showOriginalFareRules()" style="background: none; border: 1px solid #1976d2; color: #1976d2; padding: 6px 16px; border-radius: 4px; font-size: 12px; cursor: pointer;">Ver original</button></div>`;
                      } else {
                        rulesHtml += `<div style="margin-bottom: 12px; text-align: right;"><button onclick="window.__translateFareRules()" style="background: #1976d2; border: none; color: #fff; padding: 6px 16px; border-radius: 4px; font-size: 12px; cursor: pointer;">Traduzir para Português</button></div>`;
                      }

                      rulesHtml += `<div style="font-size: 13px; line-height: 1.6; color: #333;">`;
                      rulesData.forEach((segmentRule, idx) => {
                        rulesHtml += `<div style="margin-bottom: 16px;">`;
                        rulesHtml += `<div style="font-size: 15px; font-weight: 600; color: #1976d2; padding: 8px 0; border-bottom: 2px solid #1976d2; margin-bottom: 12px;">${segmentRule.departureAirport} → ${segmentRule.arrivalAirport}</div>`;

                        if (
                          segmentRule.ruleText &&
                          segmentRule.ruleText.length > 0
                        ) {
                          segmentRule.ruleText.forEach((rule) => {
                            rulesHtml += `<div style="margin-bottom: 10px;">`;
                            if (rule.title)
                              rulesHtml += `<div style="font-size: 13px; font-weight: 600; color: #555; margin-bottom: 2px;">${rule.title}</div>`;
                            if (rule.text)
                              rulesHtml += `<div style="font-size: 12px; white-space: pre-wrap; color: #444; padding-left: 8px; border-left: 2px solid #e0e0e0;">${rule.text}</div>`;
                            rulesHtml += `</div>`;
                          });
                        } else {
                          rulesHtml += `<p style="font-size: 12px;">Sem regras disponíveis para este trecho.</p>`;
                        }

                        if (idx < rulesData.length - 1) {
                          rulesHtml += `<hr style="margin: 16px 0; border: none; border-top: 1px solid #e0e0e0;"/>`;
                        }
                        rulesHtml += `</div>`;
                      });
                      rulesHtml += `</div>`;
                    } else {
                      rulesHtml =
                        "<p style='font-size: 12px;'>Regras tarifárias não disponíveis para este voo.</p>";
                    }

                    return rulesHtml;
                  })()}
                  closeButtonText="Fechar"
                  allowCloseByClickOutside={true}
                  closeButtonDisabledTillScrollEnded={false}
                />
              )}
              {/* Flight Cancellation Policy Checkbox */}
              {buscaAtual === "Aéreo" && (
                <S.FlightPolicyCheckbox>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={flightCancellationPolicyAccepted}
                        onChange={(e) =>
                          setFlightCancellationPolicyAccepted(e.target.checked)
                        }
                        color="primary"
                      />
                    }
                    label={
                      <span>
                        Li e aceito a{" "}
                        <Link
                          component="button"
                          variant="body2"
                          onClick={(e) => {
                            e.preventDefault();
                            setOpenFlightCancellationPolicyModal(true);
                          }}
                          style={{
                            fontWeight: "bold",
                            textDecoration: "underline",
                          }}
                        >
                          política de cancelamento e regras tarifárias do voo
                        </Link>
                      </span>
                    }
                  />
                </S.FlightPolicyCheckbox>
              )}
              <ThemeButton
                onClick={() => {
                  sending();
                  onSubmit();
                }}
                className={`payment ${
                  signed
                    ? userPoints < minimumPointsToBuy
                      ? "disabled"
                      : ""
                    : "disabled"
                }`}
                disabled={
                  (signed ? userPoints < minimumPointsToBuy : true) ||
                  (!useSavedCard && !!cardValidationError) ||
                  (buscaAtual === "Hotel" &&
                    !hotelCancellationPolicyAccepted) ||
                  (buscaAtual === "Aéreo" &&
                    !flightCancellationPolicyAccepted) ||
                  (requiresCpfDocument(buscaAtual) && hasInvalidCpfDocument())
                }
              >
                Comprar
              </ThemeButton>
            </Grid>
            <Grid item xs={12} md={3}>
              {buscaAtual === "Aéreo" && (
                <>
                  <FlightSideSumary
                    goingFlight={goingFlight}
                    returnFlight={returnFlight}
                    recommendation={dataSelected?.recommendation}
                    onSubmit={onSubmit}
                    sending={sending}
                    ticket={pointsPrice - fees}
                    taxaEmbarque={fees}
                    total={paymentInPoints}
                    totalApagar={paymentInMoney}
                    cashPrice={cashPrice}
                    pointsPrice={pointsPrice}
                    pointsTotalValue={pointsTotalValue}
                    cashTotalValue={cashTotalValue}
                    userPoints={userPoints}
                    minimumPointsToBuy={minimumPointsToBuy}
                    discountPoints={discountPoints}
                    discountCash={discountCash}
                    buscaAtual={buscaAtual}
                    campaignDiscountPoints={campaignDiscountPoints}
                    campaignDiscountCash={campaignDiscountCash}
                    discountPercentage={discountPercentage}
                  />
                </>
              )}
              {buscaAtual === "Carro" && (
                <CarSideSummary
                  car={dataSelected}
                  total={paymentInPoints}
                  totalApagar={paymentInMoney}
                  cashPrice={cashPrice}
                  pointsPrice={pointsPrice}
                  pointsTotalValue={pointsTotalValue}
                  cashTotalValue={cashTotalValue}
                  userPoints={userPoints}
                  minimumPointsToBuy={minimumPointsToBuy}
                  discountPoints={discountPoints}
                  discountCash={discountCash}
                  buscaAtual={buscaAtual}
                />
              )}
              {buscaAtual === "Hotel" && searchState && (
                <HotelSideSummary
                  hotel={dataSelected}
                  total={paymentInPoints}
                  totalApagar={paymentInMoney}
                  cashPrice={cashPrice}
                  pointsPrice={pointsPrice}
                  pointsTotalValue={pointsTotalValue}
                  cashTotalValue={cashTotalValue}
                  userPoints={userPoints}
                  minimumPointsToBuy={minimumPointsToBuy}
                  discountPoints={discountPoints}
                  discountCash={discountCash}
                  buscaAtual={buscaAtual}
                />
              )}
              {buscaAtual === "Experiencias" && (
                <ExperienceSideSummary
                  experience={dataSelected}
                  total={paymentInPoints}
                  totalApagar={paymentInMoney}
                  cashPrice={cashPrice}
                  pointsPrice={pointsPrice}
                  pointsTotalValue={pointsTotalValue}
                  cashTotalValue={cashTotalValue}
                  userPoints={userPoints}
                  minimumPointsToBuy={minimumPointsToBuy}
                  discountPoints={discountPoints}
                  discountCash={discountCash}
                  buscaAtual={buscaAtual}
                />
              )}
              {buscaAtual === "Rodoviário" && (
                <BusSideSummary
                  taxaEmbarque={fees}
                  userPoints={userPoints}
                  setCashPrice={setCashPrice}
                  setPointsPrice={setPointsPrice}
                  cashPrice={cashPrice}
                  pointsPrice={pointsPrice}
                  pointsTotalValue={pointsTotalValue}
                  cashTotalValue={cashTotalValue}
                  minimumPointsToBuy={minimumPointsToBuy}
                  searchState={searchState}
                  goingRoute={goingRoute}
                  returnRoute={returnRoute}
                  selectedGoingSeats={selectedGoingSeats}
                  selectedReturnSeats={selectedReturnSeats}
                  paymentInPoints={paymentInPoints}
                  paymentInMoney={paymentInMoney}
                  discountPoints={discountPoints}
                  discountCash={discountCash}
                  campaignDiscountPoints={campaignDiscountPoints}
                  campaignDiscountCash={campaignDiscountCash}
                  discountPercentage={discountPercentage}
                ></BusSideSummary>
              )}
              {buscaAtual === "Entretenimento" && (
                <EntertainmentSideSummary
                  activityCategory={activityCategory}
                  userPoints={userPoints}
                  cashPrice={cashPrice}
                  pointsPrice={pointsPrice}
                  pointsTotalValue={pointsTotalValue}
                  cashTotalValue={cashTotalValue}
                  setPointsPrice={setPointsPrice}
                  minimumPointsToBuy={minimumPointsToBuy}
                  paymentInPoints={paymentInPoints}
                  paymentInMoney={paymentInMoney}
                  discountPoints={discountPoints}
                  discountCash={discountCash}
                  campaignDiscountPoints={campaignDiscountPoints}
                  campaignDiscountCash={campaignDiscountCash}
                  discountPercentage={discountPercentage}
                ></EntertainmentSideSummary>
              )}
              {buscaAtual === "Pacote" && (
                <PackageSideSummary
                  total={paymentInPoints}
                  totalApagar={paymentInMoney}
                  cashPrice={cashPrice}
                  pointsPrice={pointsPrice}
                  pointsTotalValue={pointsTotalValue}
                  cashTotalValue={cashTotalValue}
                  userPoints={userPoints}
                  minimumPointsToBuy={minimumPointsToBuy}
                  discountPoints={discountPoints}
                  discountCash={discountCash}
                />
              )}
            </Grid>
          </Grid>
        </S.Content>
      </Container>
    </S.Wrapper>
  );
};

export default SummaryContent;
